// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =======================================================================
   PORTFOLIO RISK CONCENTRATION MODULE STYLES - SCOPED

   All styles are scoped under .portfolio-risk-concentration-theme and
   .portfolio-risk-concentration-root to prevent conflicts with platform-ui
   styles.

   Standard theme tokens reuse the same Athena dark palette as
   UnderwritingEngineV2 (see assets/css/UnderwritingEngineV2/style.css) for
   visual consistency across feature modules. The --amber/--amber-dim/
   --approve/--decline/--bar-muted tokens are new — tailwind.config.js
   already references them (colors.amber, colors.approve, etc.) but nothing
   previously defined their actual values.
   ======================================================================= */

/* Required for @layer below to resolve — webpack's css-loader/postcss
   pipeline processes each imported CSS file as its own unit, so @layer
   needs its matching @tailwind directive present in THIS file even though
   src/index.css already loads Tailwind globally (same reason
   UnderwritingEngineV2/style.css includes these too). */
*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
.container {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 2rem;
    padding-left: 2rem;
}
@media (min-width: 1400px) {
    .container {
        max-width: 1400px;
    }
}
.portfolio-risk-concentration-theme {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    min-height: 100vh;
    background-color: hsl(var(--background));
    color: hsl(var(--foreground));
  }
/* Tailwind preflight is disabled globally (corePlugins.preflight: false in
     tailwind.config.js) to avoid conflicting with Bootstrap. Re-apply just
     the box-model/typography reset here, scoped to this feature only. */
.portfolio-risk-concentration-theme *,
  .portfolio-risk-concentration-theme *::before,
  .portfolio-risk-concentration-theme *::after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: hsl(var(--border));
  }
.portfolio-risk-concentration-theme {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
  }
.portfolio-risk-concentration-theme hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
.portfolio-risk-concentration-theme b,
  .portfolio-risk-concentration-theme strong {
    font-weight: bolder;
  }
.portfolio-risk-concentration-theme code,
  .portfolio-risk-concentration-theme kbd,
  .portfolio-risk-concentration-theme samp,
  .portfolio-risk-concentration-theme pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em;
  }
.portfolio-risk-concentration-theme small {
    font-size: 80%;
  }
.portfolio-risk-concentration-theme sub,
  .portfolio-risk-concentration-theme sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
.portfolio-risk-concentration-theme sub {
    bottom: -0.25em;
  }
.portfolio-risk-concentration-theme sup {
    top: -0.5em;
  }
.portfolio-risk-concentration-theme table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
.portfolio-risk-concentration-theme button,
  .portfolio-risk-concentration-theme input,
  .portfolio-risk-concentration-theme optgroup,
  .portfolio-risk-concentration-theme select,
  .portfolio-risk-concentration-theme textarea {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
  }
.portfolio-risk-concentration-theme button,
  .portfolio-risk-concentration-theme select {
    text-transform: none;
  }
.portfolio-risk-concentration-theme button,
  .portfolio-risk-concentration-theme [type='button'],
  .portfolio-risk-concentration-theme [type='reset'],
  .portfolio-risk-concentration-theme [type='submit'] {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
  }
.portfolio-risk-concentration-theme :-moz-focusring {
    outline: auto;
  }
.portfolio-risk-concentration-theme :-moz-ui-invalid {
    box-shadow: none;
  }
.portfolio-risk-concentration-theme progress {
    vertical-align: baseline;
  }
.portfolio-risk-concentration-theme ::-webkit-inner-spin-button,
  .portfolio-risk-concentration-theme ::-webkit-outer-spin-button {
    height: auto;
  }
.portfolio-risk-concentration-theme [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
.portfolio-risk-concentration-theme ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
.portfolio-risk-concentration-theme ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
.portfolio-risk-concentration-theme summary {
    display: list-item;
  }
.portfolio-risk-concentration-theme blockquote,
  .portfolio-risk-concentration-theme dl,
  .portfolio-risk-concentration-theme dd,
  .portfolio-risk-concentration-theme figure,
  .portfolio-risk-concentration-theme h1,
  .portfolio-risk-concentration-theme h2,
  .portfolio-risk-concentration-theme h3,
  .portfolio-risk-concentration-theme h4,
  .portfolio-risk-concentration-theme h5,
  .portfolio-risk-concentration-theme h6,
  .portfolio-risk-concentration-theme hr,
  .portfolio-risk-concentration-theme p,
  .portfolio-risk-concentration-theme pre {
    margin: 0;
  }
.portfolio-risk-concentration-theme fieldset {
    margin: 0;
    padding: 0;
  }
.portfolio-risk-concentration-theme legend {
    padding: 0;
  }
.portfolio-risk-concentration-theme ol,
  .portfolio-risk-concentration-theme ul,
  .portfolio-risk-concentration-theme menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }
.portfolio-risk-concentration-theme dialog {
    padding: 0;
  }
.portfolio-risk-concentration-theme textarea {
    resize: vertical;
  }
.portfolio-risk-concentration-theme input::placeholder,
  .portfolio-risk-concentration-theme textarea::placeholder {
    opacity: 1;
    color: hsl(var(--muted-foreground));
  }
.portfolio-risk-concentration-theme button,
  .portfolio-risk-concentration-theme [role="button"] {
    cursor: pointer;
  }
.portfolio-risk-concentration-theme :disabled {
    cursor: default;
  }
.portfolio-risk-concentration-theme img,
  .portfolio-risk-concentration-theme svg,
  .portfolio-risk-concentration-theme video,
  .portfolio-risk-concentration-theme canvas,
  .portfolio-risk-concentration-theme audio,
  .portfolio-risk-concentration-theme iframe,
  .portfolio-risk-concentration-theme embed,
  .portfolio-risk-concentration-theme object {
    display: block;
    vertical-align: middle;
  }
.portfolio-risk-concentration-theme img,
  .portfolio-risk-concentration-theme video {
    max-width: 100%;
    height: auto;
  }
.portfolio-risk-concentration-theme [hidden] {
    display: none;
  }
.portfolio-risk-concentration-theme h1,
  .portfolio-risk-concentration-theme h2,
  .portfolio-risk-concentration-theme h3,
  .portfolio-risk-concentration-theme h4,
  .portfolio-risk-concentration-theme h5,
  .portfolio-risk-concentration-theme h6 {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    font-weight: 600;
    letter-spacing: -0.025em;
  }
.portfolio-risk-concentration-theme a {
    color: inherit;
    text-decoration: none;
  }
.portfolio-risk-concentration-theme button {
    font-family: inherit;
  }
.sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border-width: 0 !important;
}
.pointer-events-none {
    pointer-events: none !important;
}
.pointer-events-auto {
    pointer-events: auto !important;
}
.visible {
    visibility: visible !important;
}
.invisible {
    visibility: hidden !important;
}
.collapse {
    visibility: collapse !important;
}
.static {
    position: static !important;
}
.fixed {
    position: fixed !important;
}
.absolute {
    position: absolute !important;
}
.relative {
    position: relative !important;
}
.inset-0 {
    inset: 0px !important;
}
.inset-4 {
    inset: 1rem !important;
}
.inset-x-0 {
    left: 0px !important;
    right: 0px !important;
}
.inset-y-0 {
    top: 0px !important;
    bottom: 0px !important;
}
.-bottom-12 {
    bottom: -3rem !important;
}
.-left-12 {
    left: -3rem !important;
}
.-right-1\\.5 {
    right: -0.375rem !important;
}
.-right-12 {
    right: -3rem !important;
}
.-top-1\\.5 {
    top: -0.375rem !important;
}
.-top-12 {
    top: -3rem !important;
}
.bottom-0 {
    bottom: 0px !important;
}
.bottom-4 {
    bottom: 1rem !important;
}
.left-0 {
    left: 0px !important;
}
.left-1 {
    left: 0.25rem !important;
}
.left-1\\/2 {
    left: 50% !important;
}
.left-2 {
    left: 0.5rem !important;
}
.left-3 {
    left: 0.75rem !important;
}
.left-\\[50\\%\\] {
    left: 50% !important;
}
.right-0 {
    right: 0px !important;
}
.right-1 {
    right: 0.25rem !important;
}
.right-2 {
    right: 0.5rem !important;
}
.right-3 {
    right: 0.75rem !important;
}
.right-4 {
    right: 1rem !important;
}
.top-0 {
    top: 0px !important;
}
.top-1\\/2 {
    top: 50% !important;
}
.top-2 {
    top: 0.5rem !important;
}
.top-3 {
    top: 0.75rem !important;
}
.top-4 {
    top: 1rem !important;
}
.top-\\[110px\\] {
    top: 110px !important;
}
.top-\\[1px\\] {
    top: 1px !important;
}
.top-\\[200px\\] {
    top: 200px !important;
}
.top-\\[50\\%\\] {
    top: 50% !important;
}
.top-\\[60\\%\\] {
    top: 60% !important;
}
.top-full {
    top: 100% !important;
}
.\\!z-\\[9999\\] {
    z-index: 9999 !important;
}
.z-10 {
    z-index: 10 !important;
}
.z-40 {
    z-index: 40 !important;
}
.z-50 {
    z-index: 50 !important;
}
.z-\\[100\\] {
    z-index: 100 !important;
}
.z-\\[1\\] {
    z-index: 1 !important;
}
.order-1 {
    order: 1 !important;
}
.order-2 {
    order: 2 !important;
}
.order-3 {
    order: 3 !important;
}
.order-4 {
    order: 4 !important;
}
.order-5 {
    order: 5 !important;
}
.order-6 {
    order: 6 !important;
}
.col-span-2 {
    grid-column: span 2 / span 2 !important;
}
.col-span-3 {
    grid-column: span 3 / span 3 !important;
}
.col-span-4 {
    grid-column: span 4 / span 4 !important;
}
.col-start-1 {
    grid-column-start: 1 !important;
}
.col-start-2 {
    grid-column-start: 2 !important;
}
.row-span-3 {
    grid-row: span 3 / span 3 !important;
}
.row-span-5 {
    grid-row: span 5 / span 5 !important;
}
.row-start-1 {
    grid-row-start: 1 !important;
}
.row-start-2 {
    grid-row-start: 2 !important;
}
.row-start-3 {
    grid-row-start: 3 !important;
}
.float-end {
    float: inline-end !important;
}
.-mx-1 {
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
}
.-mx-2 {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
}
.mx-0 {
    margin-left: 0px !important;
    margin-right: 0px !important;
}
.mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
}
.mx-1\\.5 {
    margin-left: 0.375rem !important;
    margin-right: 0.375rem !important;
}
.mx-5 {
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
}
.mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}
.my-0\\.5 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
}
.my-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
}
.my-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
}
.\\!mt-\\[5\\.5rem\\] {
    margin-top: 5.5rem !important;
}
.-ml-4 {
    margin-left: -1rem !important;
}
.-mt-2 {
    margin-top: -0.5rem !important;
}
.-mt-4 {
    margin-top: -1rem !important;
}
.mb-0 {
    margin-bottom: 0px !important;
}
.mb-0\\.5 {
    margin-bottom: 0.125rem !important;
}
.mb-1 {
    margin-bottom: 0.25rem !important;
}
.mb-2 {
    margin-bottom: 0.5rem !important;
}
.mb-3 {
    margin-bottom: 0.75rem !important;
}
.mb-4 {
    margin-bottom: 1rem !important;
}
.mb-5 {
    margin-bottom: 1.25rem !important;
}
.mb-6 {
    margin-bottom: 1.5rem !important;
}
.me-2 {
    margin-inline-end: 0.5rem !important;
}
.me-4 {
    margin-inline-end: 1rem !important;
}
.ml-0\\.5 {
    margin-left: 0.125rem !important;
}
.ml-1 {
    margin-left: 0.25rem !important;
}
.ml-1\\.5 {
    margin-left: 0.375rem !important;
}
.ml-2 {
    margin-left: 0.5rem !important;
}
.ml-3 {
    margin-left: 0.75rem !important;
}
.ml-4 {
    margin-left: 1rem !important;
}
.ml-7 {
    margin-left: 1.75rem !important;
}
.ml-auto {
    margin-left: auto !important;
}
.mr-1 {
    margin-right: 0.25rem !important;
}
.mr-1\\.5 {
    margin-right: 0.375rem !important;
}
.mr-2 {
    margin-right: 0.5rem !important;
}
.mr-3 {
    margin-right: 0.75rem !important;
}
.ms-0 {
    margin-inline-start: 0px !important;
}
.ms-2 {
    margin-inline-start: 0.5rem !important;
}
.ms-3 {
    margin-inline-start: 0.75rem !important;
}
.ms-4 {
    margin-inline-start: 1rem !important;
}
.mt-0 {
    margin-top: 0px !important;
}
.mt-0\\.5 {
    margin-top: 0.125rem !important;
}
.mt-1 {
    margin-top: 0.25rem !important;
}
.mt-1\\.5 {
    margin-top: 0.375rem !important;
}
.mt-12 {
    margin-top: 3rem !important;
}
.mt-2 {
    margin-top: 0.5rem !important;
}
.mt-24 {
    margin-top: 6rem !important;
}
.mt-3 {
    margin-top: 0.75rem !important;
}
.mt-4 {
    margin-top: 1rem !important;
}
.mt-5 {
    margin-top: 1.25rem !important;
}
.mt-6 {
    margin-top: 1.5rem !important;
}
.mt-8 {
    margin-top: 2rem !important;
}
.mt-auto {
    margin-top: auto !important;
}
.-mb-4 {
    margin-bottom: -1rem !important;
}
.block {
    display: block !important;
}
.inline-block {
    display: inline-block !important;
}
.inline {
    display: inline !important;
}
.flex {
    display: flex !important;
}
.inline-flex {
    display: inline-flex !important;
}
.\\!table {
    display: table !important;
}
.table {
    display: table !important;
}
.table-cell {
    display: table-cell !important;
}
.grid {
    display: grid !important;
}
.contents {
    display: contents !important;
}
.hidden {
    display: none !important;
}
.aspect-square {
    aspect-ratio: 1 / 1 !important;
}
.aspect-video {
    aspect-ratio: 16 / 9 !important;
}
.size-2 {
    width: 0.5rem !important;
    height: 0.5rem !important;
}
.size-2\\.5 {
    width: 0.625rem !important;
    height: 0.625rem !important;
}
.size-3 {
    width: 0.75rem !important;
    height: 0.75rem !important;
}
.size-3\\.5 {
    width: 0.875rem !important;
    height: 0.875rem !important;
}
.size-4 {
    width: 1rem !important;
    height: 1rem !important;
}
.size-5 {
    width: 1.25rem !important;
    height: 1.25rem !important;
}
.size-6 {
    width: 1.5rem !important;
    height: 1.5rem !important;
}
.size-8 {
    width: 2rem !important;
    height: 2rem !important;
}
.h-0\\.5 {
    height: 0.125rem !important;
}
.h-1\\.5 {
    height: 0.375rem !important;
}
.h-10 {
    height: 2.5rem !important;
}
.h-11 {
    height: 2.75rem !important;
}
.h-12 {
    height: 3rem !important;
}
.h-16 {
    height: 4rem !important;
}
.h-2 {
    height: 0.5rem !important;
}
.h-2\\.5 {
    height: 0.625rem !important;
}
.h-20 {
    height: 5rem !important;
}
.h-24 {
    height: 6rem !important;
}
.h-28 {
    height: 7rem !important;
}
.h-3 {
    height: 0.75rem !important;
}
.h-3\\.5 {
    height: 0.875rem !important;
}
.h-32 {
    height: 8rem !important;
}
.h-36 {
    height: 9rem !important;
}
.h-4 {
    height: 1rem !important;
}
.h-40 {
    height: 10rem !important;
}
.h-48 {
    height: 12rem !important;
}
.h-5 {
    height: 1.25rem !important;
}
.h-52 {
    height: 13rem !important;
}
.h-6 {
    height: 1.5rem !important;
}
.h-60 {
    height: 15rem !important;
}
.h-64 {
    height: 16rem !important;
}
.h-7 {
    height: 1.75rem !important;
}
.h-72 {
    height: 18rem !important;
}
.h-8 {
    height: 2rem !important;
}
.h-80 {
    height: 20rem !important;
}
.h-9 {
    height: 2.25rem !important;
}
.h-96 {
    height: 24rem !important;
}
.h-\\[120px\\] {
    height: 120px !important;
}
.h-\\[132px\\] {
    height: 132px !important;
}
.h-\\[1px\\] {
    height: 1px !important;
}
.h-\\[220px\\] {
    height: 220px !important;
}
.h-\\[260px\\] {
    height: 260px !important;
}
.h-\\[280px\\] {
    height: 280px !important;
}
.h-\\[2px\\] {
    height: 2px !important;
}
.h-\\[300px\\] {
    height: 300px !important;
}
.h-\\[320px\\] {
    height: 320px !important;
}
.h-\\[340px\\] {
    height: 340px !important;
}
.h-\\[34px\\] {
    height: 34px !important;
}
.h-\\[360px\\] {
    height: 360px !important;
}
.h-\\[400px\\] {
    height: 400px !important;
}
.h-\\[420px\\] {
    height: 420px !important;
}
.h-\\[460px\\] {
    height: 460px !important;
}
.h-\\[520px\\] {
    height: 520px !important;
}
.h-\\[52px\\] {
    height: 52px !important;
}
.h-\\[560px\\] {
    height: 560px !important;
}
.h-\\[70px\\] {
    height: 70px !important;
}
.h-\\[90px\\] {
    height: 90px !important;
}
.h-\\[92px\\] {
    height: 92px !important;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
    height: var(--radix-navigation-menu-viewport-height) !important;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height) !important;
}
.h-auto {
    height: auto !important;
}
.h-full {
    height: 100% !important;
}
.h-px {
    height: 1px !important;
}
.h-screen {
    height: 100vh !important;
}
.max-h-48 {
    max-height: 12rem !important;
}
.max-h-56 {
    max-height: 14rem !important;
}
.max-h-64 {
    max-height: 16rem !important;
}
.max-h-72 {
    max-height: 18rem !important;
}
.max-h-96 {
    max-height: 24rem !important;
}
.max-h-\\[300px\\] {
    max-height: 300px !important;
}
.max-h-\\[320px\\] {
    max-height: 320px !important;
}
.max-h-\\[82vh\\] {
    max-height: 82vh !important;
}
.max-h-\\[85vh\\] {
    max-height: 85vh !important;
}
.max-h-\\[86vh\\] {
    max-height: 86vh !important;
}
.max-h-\\[90vh\\] {
    max-height: 90vh !important;
}
.max-h-screen {
    max-height: 100vh !important;
}
.max-h-\\[32rem\\] {
    max-height: 32rem !important;
}
.min-h-0 {
    min-height: 0px !important;
}
.min-h-20 {
    min-height: 5rem !important;
}
.min-h-24 {
    min-height: 6rem !important;
}
.min-h-64 {
    min-height: 16rem !important;
}
.min-h-\\[100px\\] {
    min-height: 100px !important;
}
.min-h-\\[110px\\] {
    min-height: 110px !important;
}
.min-h-\\[60vh\\] {
    min-height: 60vh !important;
}
.min-h-\\[64px\\] {
    min-height: 64px !important;
}
.min-h-\\[80px\\] {
    min-height: 80px !important;
}
.min-h-screen {
    min-height: 100vh !important;
}
.w-0 {
    width: 0px !important;
}
.w-1 {
    width: 0.25rem !important;
}
.w-1\\.5 {
    width: 0.375rem !important;
}
.w-1\\/3 {
    width: 33.333333% !important;
}
.w-10 {
    width: 2.5rem !important;
}
.w-11 {
    width: 2.75rem !important;
}
.w-16 {
    width: 4rem !important;
}
.w-2 {
    width: 0.5rem !important;
}
.w-2\\.5 {
    width: 0.625rem !important;
}
.w-20 {
    width: 5rem !important;
}
.w-24 {
    width: 6rem !important;
}
.w-28 {
    width: 7rem !important;
}
.w-3 {
    width: 0.75rem !important;
}
.w-3\\.5 {
    width: 0.875rem !important;
}
.w-3\\/4 {
    width: 75% !important;
}
.w-32 {
    width: 8rem !important;
}
.w-36 {
    width: 9rem !important;
}
.w-4 {
    width: 1rem !important;
}
.w-40 {
    width: 10rem !important;
}
.w-48 {
    width: 12rem !important;
}
.w-5 {
    width: 1.25rem !important;
}
.w-52 {
    width: 13rem !important;
}
.w-56 {
    width: 14rem !important;
}
.w-6 {
    width: 1.5rem !important;
}
.w-64 {
    width: 16rem !important;
}
.w-7 {
    width: 1.75rem !important;
}
.w-72 {
    width: 18rem !important;
}
.w-8 {
    width: 2rem !important;
}
.w-80 {
    width: 20rem !important;
}
.w-9 {
    width: 2.25rem !important;
}
.w-\\[10\\%\\] {
    width: 10% !important;
}
.w-\\[100px\\] {
    width: 100px !important;
}
.w-\\[105px\\] {
    width: 105px !important;
}
.w-\\[110px\\] {
    width: 110px !important;
}
.w-\\[12\\%\\] {
    width: 12% !important;
}
.w-\\[120px\\] {
    width: 120px !important;
}
.w-\\[130px\\] {
    width: 130px !important;
}
.w-\\[14\\%\\] {
    width: 14% !important;
}
.w-\\[140px\\] {
    width: 140px !important;
}
.w-\\[15\\%\\] {
    width: 15% !important;
}
.w-\\[150px\\] {
    width: 150px !important;
}
.w-\\[16\\%\\] {
    width: 16% !important;
}
.w-\\[160px\\] {
    width: 160px !important;
}
.w-\\[168px\\] {
    width: 168px !important;
}
.w-\\[170px\\] {
    width: 170px !important;
}
.w-\\[180px\\] {
    width: 180px !important;
}
.w-\\[1px\\] {
    width: 1px !important;
}
.w-\\[200px\\] {
    width: 200px !important;
}
.w-\\[220px\\] {
    width: 220px !important;
}
.w-\\[230px\\] {
    width: 230px !important;
}
.w-\\[240px\\] {
    width: 240px !important;
}
.w-\\[25\\%\\] {
    width: 25% !important;
}
.w-\\[2px\\] {
    width: 2px !important;
}
.w-\\[300px\\] {
    width: 300px !important;
}
.w-\\[32\\%\\] {
    width: 32% !important;
}
.w-\\[3px\\] {
    width: 3px !important;
}
.w-\\[7\\%\\] {
    width: 7% !important;
}
.w-\\[8\\%\\] {
    width: 8% !important;
}
.w-\\[9\\%\\] {
    width: 9% !important;
}
.w-\\[90px\\] {
    width: 90px !important;
}
.w-auto {
    width: auto !important;
}
.w-fit {
    width: fit-content !important;
}
.w-full {
    width: 100% !important;
}
.w-max {
    width: max-content !important;
}
.w-px {
    width: 1px !important;
}
.w-12 {
    width: 3rem !important;
}
.w-\\[var\\(--radix-popover-trigger-width\\)\\] {
    width: var(--radix-popover-trigger-width) !important;
}
.min-w-0 {
    min-width: 0px !important;
}
.min-w-\\[1000px\\] {
    min-width: 1000px !important;
}
.min-w-\\[100px\\] {
    min-width: 100px !important;
}
.min-w-\\[1100px\\] {
    min-width: 1100px !important;
}
.min-w-\\[110px\\] {
    min-width: 110px !important;
}
.min-w-\\[120px\\] {
    min-width: 120px !important;
}
.min-w-\\[12rem\\] {
    min-width: 12rem !important;
}
.min-w-\\[130px\\] {
    min-width: 130px !important;
}
.min-w-\\[1320px\\] {
    min-width: 1320px !important;
}
.min-w-\\[1360px\\] {
    min-width: 1360px !important;
}
.min-w-\\[150px\\] {
    min-width: 150px !important;
}
.min-w-\\[1520px\\] {
    min-width: 1520px !important;
}
.min-w-\\[160px\\] {
    min-width: 160px !important;
}
.min-w-\\[16px\\] {
    min-width: 16px !important;
}
.min-w-\\[16rem\\] {
    min-width: 16rem !important;
}
.min-w-\\[18rem\\] {
    min-width: 18rem !important;
}
.min-w-\\[200px\\] {
    min-width: 200px !important;
}
.min-w-\\[720px\\] {
    min-width: 720px !important;
}
.min-w-\\[74px\\] {
    min-width: 74px !important;
}
.min-w-\\[820px\\] {
    min-width: 820px !important;
}
.min-w-\\[84px\\] {
    min-width: 84px !important;
}
.min-w-\\[860px\\] {
    min-width: 860px !important;
}
.min-w-\\[8rem\\] {
    min-width: 8rem !important;
}
.min-w-\\[900px\\] {
    min-width: 900px !important;
}
.min-w-\\[960px\\] {
    min-width: 960px !important;
}
.min-w-\\[980px\\] {
    min-width: 980px !important;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width) !important;
}
.min-w-max {
    min-width: max-content !important;
}
.min-w-\\[640px\\] {
    min-width: 640px !important;
}
.min-w-\\[1200px\\] {
    min-width: 1200px !important;
}
.min-w-\\[128px\\] {
    min-width: 128px !important;
}
.min-w-\\[280px\\] {
    min-width: 280px !important;
}
.max-w-24 {
    max-width: 6rem !important;
}
.max-w-2xl {
    max-width: 42rem !important;
}
.max-w-3xl {
    max-width: 48rem !important;
}
.max-w-4xl {
    max-width: 56rem !important;
}
.max-w-6xl {
    max-width: 72rem !important;
}
.max-w-7xl {
    max-width: 80rem !important;
}
.max-w-\\[220px\\] {
    max-width: 220px !important;
}
.max-w-\\[22rem\\] {
    max-width: 22rem !important;
}
.max-w-\\[240px\\] {
    max-width: 240px !important;
}
.max-w-\\[260px\\] {
    max-width: 260px !important;
}
.max-w-\\[280px\\] {
    max-width: 280px !important;
}
.max-w-\\[300px\\] {
    max-width: 300px !important;
}
.max-w-\\[340px\\] {
    max-width: 340px !important;
}
.max-w-full {
    max-width: 100% !important;
}
.max-w-lg {
    max-width: 32rem !important;
}
.max-w-max {
    max-width: max-content !important;
}
.max-w-md {
    max-width: 28rem !important;
}
.max-w-sm {
    max-width: 24rem !important;
}
.max-w-xl {
    max-width: 36rem !important;
}
.max-w-xs {
    max-width: 20rem !important;
}
.max-w-\\[200px\\] {
    max-width: 200px !important;
}
.flex-1 {
    flex: 1 1 !important;
}
.shrink {
    flex-shrink: 1 !important;
}
.shrink-0 {
    flex-shrink: 0 !important;
}
.grow {
    flex-grow: 1 !important;
}
.grow-0 {
    flex-grow: 0 !important;
}
.basis-full {
    flex-basis: 100% !important;
}
.table-fixed {
    table-layout: fixed !important;
}
.caption-bottom {
    caption-side: bottom !important;
}
.border-collapse {
    border-collapse: collapse !important;
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-45 {
    --tw-rotate: 45deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-90 {
    --tw-rotate: 90deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
.animate-fade-in {
    animation: fade-in 200ms ease-out !important;
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite !important;
}
.cursor-default {
    cursor: default !important;
}
.cursor-help {
    cursor: help !important;
}
.cursor-not-allowed {
    cursor: not-allowed !important;
}
.cursor-pointer {
    cursor: pointer !important;
}
.cursor-grab {
    cursor: grab !important;
}
.touch-none {
    touch-action: none !important;
}
.select-none {
    -webkit-user-select: none !important;
            user-select: none !important;
}
.select-all {
    -webkit-user-select: all !important;
            user-select: all !important;
}
.resize {
    resize: both !important;
}
.scroll-mt-\\[200px\\] {
    scroll-margin-top: 200px !important;
}
.list-none {
    list-style-type: none !important;
}
.auto-cols-\\[minmax\\(160px\\2c 1fr\\)\\] {
    grid-auto-columns: minmax(160px,1fr) !important;
}
.auto-cols-\\[minmax\\(160px\\2c auto\\)\\] {
    grid-auto-columns: minmax(160px,auto) !important;
}
.grid-flow-col {
    grid-auto-flow: column !important;
}
.auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr) !important;
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}
.grid-cols-\\[1\\.3fr_2fr_2fr\\] {
    grid-template-columns: 1.3fr 2fr 2fr !important;
}
.grid-cols-\\[1fr_1fr_8rem_8rem_2\\.25rem\\] {
    grid-template-columns: 1fr 1fr 8rem 8rem 2.25rem !important;
}
.grid-cols-\\[8rem_9rem_1fr\\] {
    grid-template-columns: 8rem 9rem 1fr !important;
}
.grid-cols-\\[1rem_minmax\\(0\\2c 1fr\\)_1\\.5rem_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 1rem minmax(0,1fr) 1.5rem minmax(0,1fr) !important;
}
.grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto !important;
}
.grid-rows-\\[auto_auto_auto\\] {
    grid-template-rows: auto auto auto !important;
}
.flex-row {
    flex-direction: row !important;
}
.flex-row-reverse {
    flex-direction: row-reverse !important;
}
.flex-col {
    flex-direction: column !important;
}
.flex-col-reverse {
    flex-direction: column-reverse !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}
.flex-nowrap {
    flex-wrap: nowrap !important;
}
.place-items-center {
    place-items: center !important;
}
.items-start {
    align-items: flex-start !important;
}
.items-end {
    align-items: flex-end !important;
}
.items-center {
    align-items: center !important;
}
.items-baseline {
    align-items: baseline !important;
}
.items-stretch {
    align-items: stretch !important;
}
.justify-start {
    justify-content: flex-start !important;
}
.justify-end {
    justify-content: flex-end !important;
}
.justify-center {
    justify-content: center !important;
}
.justify-between {
    justify-content: space-between !important;
}
.gap-0 {
    gap: 0px !important;
}
.gap-0\\.5 {
    gap: 0.125rem !important;
}
.gap-1 {
    gap: 0.25rem !important;
}
.gap-1\\.5 {
    gap: 0.375rem !important;
}
.gap-2 {
    gap: 0.5rem !important;
}
.gap-3 {
    gap: 0.75rem !important;
}
.gap-4 {
    gap: 1rem !important;
}
.gap-5 {
    gap: 1.25rem !important;
}
.gap-6 {
    gap: 1.5rem !important;
}
.gap-8 {
    gap: 2rem !important;
}
.gap-x-4 {
    column-gap: 1rem !important;
}
.gap-x-6 {
    column-gap: 1.5rem !important;
}
.gap-x-8 {
    column-gap: 2rem !important;
}
.gap-y-0 {
    row-gap: 0px !important;
}
.gap-y-1 {
    row-gap: 0.25rem !important;
}
.gap-y-2 {
    row-gap: 0.5rem !important;
}
.gap-y-3 {
    row-gap: 0.75rem !important;
}
.gap-x-5 {
    column-gap: 1.25rem !important;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.125rem * var(--tw-space-y-reverse)) !important;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.375rem * var(--tw-space-y-reverse)) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(2rem * var(--tw-space-y-reverse)) !important;
}
.space-y-\\[10px\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(10px * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(10px * var(--tw-space-y-reverse)) !important;
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0 !important;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse))) !important;
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse)) !important;
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
    border-color: hsl(var(--border)) !important;
}
.divide-border\\/60 > :not([hidden]) ~ :not([hidden]) {
    border-color: hsl(var(--border) / 0.6) !important;
}
.self-start {
    align-self: flex-start !important;
}
.overflow-auto {
    overflow: auto !important;
}
.overflow-hidden {
    overflow: hidden !important;
}
.overflow-x-auto {
    overflow-x: auto !important;
}
.overflow-y-auto {
    overflow-y: auto !important;
}
.overflow-x-hidden {
    overflow-x: hidden !important;
}
.scroll-smooth {
    scroll-behavior: smooth !important;
}
.truncate {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}
.whitespace-nowrap {
    white-space: nowrap !important;
}
.whitespace-pre {
    white-space: pre !important;
}
.whitespace-pre-line {
    white-space: pre-line !important;
}
.whitespace-pre-wrap {
    white-space: pre-wrap !important;
}
.break-words {
    overflow-wrap: break-word !important;
}
.rounded {
    border-radius: 0.25rem !important;
}
.rounded-\\[2px\\] {
    border-radius: 2px !important;
}
.rounded-\\[3px\\] {
    border-radius: 3px !important;
}
.rounded-\\[inherit\\] {
    border-radius: inherit !important;
}
.rounded-full {
    border-radius: 9999px !important;
}
.rounded-lg {
    border-radius: 0px !important;
}
.rounded-md {
    border-radius: 0px !important;
}
.rounded-sm {
    border-radius: 0px !important;
}
.rounded-xl {
    border-radius: 0.75rem !important;
}
.rounded-t-\\[10px\\] {
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
}
.rounded-tl-sm {
    border-top-left-radius: 0px !important;
}
.\\!border-0 {
    border-width: 0px !important;
}
.border {
    border-width: 1px !important;
}
.border-0 {
    border-width: 0px !important;
}
.border-2 {
    border-width: 2px !important;
}
.border-\\[1\\.5px\\] {
    border-width: 1.5px !important;
}
.border-y {
    border-top-width: 1px !important;
    border-bottom-width: 1px !important;
}
.border-b {
    border-bottom-width: 1px !important;
}
.border-b-0 {
    border-bottom-width: 0px !important;
}
.border-l {
    border-left-width: 1px !important;
}
.border-r {
    border-right-width: 1px !important;
}
.border-t {
    border-top-width: 1px !important;
}
.border-t-2 {
    border-top-width: 2px !important;
}
.border-dashed {
    border-style: dashed !important;
}
.border-\\[--color-border\\] {
    border-color: var(--color-border) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 24\\%\\)\\] {
    --tw-border-opacity: 1 !important;
    border-color: hsl(216 11% 24% / var(--tw-border-opacity, 1)) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 26\\%\\)\\] {
    --tw-border-opacity: 1 !important;
    border-color: hsl(216 11% 26% / var(--tw-border-opacity, 1)) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 28\\%\\)\\] {
    --tw-border-opacity: 1 !important;
    border-color: hsl(216 11% 28% / var(--tw-border-opacity, 1)) !important;
}
.border-\\[hsl\\(216\\2c 11\\%\\2c 30\\%\\)\\] {
    --tw-border-opacity: 1 !important;
    border-color: hsl(216 11% 30% / var(--tw-border-opacity, 1)) !important;
}
.border-blue-400 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}
.border-border {
    border-color: hsl(var(--border)) !important;
}
.border-border\\/20 {
    border-color: hsl(var(--border) / 0.2) !important;
}
.border-border\\/30 {
    border-color: hsl(var(--border) / 0.3) !important;
}
.border-border\\/40 {
    border-color: hsl(var(--border) / 0.4) !important;
}
.border-border\\/50 {
    border-color: hsl(var(--border) / 0.5) !important;
}
.border-border\\/60 {
    border-color: hsl(var(--border) / 0.6) !important;
}
.border-border\\/70 {
    border-color: hsl(var(--border) / 0.7) !important;
}
.border-destructive {
    border-color: hsl(var(--destructive)) !important;
}
.border-destructive\\/40 {
    border-color: hsl(var(--destructive) / 0.4) !important;
}
.border-destructive\\/50 {
    border-color: hsl(var(--destructive) / 0.5) !important;
}
.border-destructive\\/60 {
    border-color: hsl(var(--destructive) / 0.6) !important;
}
.border-foreground {
    border-color: hsl(var(--foreground)) !important;
}
.border-foreground\\/50 {
    border-color: hsl(var(--foreground) / 0.5) !important;
}
.border-input {
    border-color: hsl(var(--input)) !important;
}
.border-muted-foreground {
    border-color: hsl(var(--muted-foreground)) !important;
}
.border-muted-foreground\\/40 {
    border-color: hsl(var(--muted-foreground) / 0.4) !important;
}
.border-muted-foreground\\/50 {
    border-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.border-primary {
    border-color: hsl(var(--primary)) !important;
}
.border-primary\\/25 {
    border-color: hsl(var(--primary) / 0.25) !important;
}
.border-primary\\/30 {
    border-color: hsl(var(--primary) / 0.3) !important;
}
.border-primary\\/40 {
    border-color: hsl(var(--primary) / 0.4) !important;
}
.border-primary\\/50 {
    border-color: hsl(var(--primary) / 0.5) !important;
}
.border-primary\\/60 {
    border-color: hsl(var(--primary) / 0.6) !important;
}
.border-red-600 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1)) !important;
}
.border-secondary-foreground\\/60 {
    border-color: hsl(var(--secondary-foreground) / 0.6) !important;
}
.border-success {
    border-color: hsl(var(--success)) !important;
}
.border-transparent {
    border-color: transparent !important;
}
.border-l-transparent {
    border-left-color: transparent !important;
}
.border-t-transparent {
    border-top-color: transparent !important;
}
.bg-\\[--color-bg\\] {
    background-color: var(--color-bg) !important;
}
.bg-\\[color-mix\\(in_oklch\\2c var\\(--approve\\)_18\\%\\2c transparent\\)\\] {
    background-color: color-mix(in oklch,var(--approve) 18%,transparent) !important;
}
.bg-\\[color-mix\\(in_oklch\\2c var\\(--decline\\)_18\\%\\2c transparent\\)\\] {
    background-color: color-mix(in oklch,var(--decline) 18%,transparent) !important;
}
.bg-\\[hsl\\(216\\2c 11\\%\\2c 13\\%\\)\\] {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(216 11% 13% / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[hsl\\(216\\2c 11\\%\\2c 14\\%\\)\\] {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(216 11% 14% / var(--tw-bg-opacity, 1)) !important;
}
.bg-accent {
    background-color: hsl(var(--accent)) !important;
}
.bg-amber {
    background-color: var(--amber) !important;
}
.bg-amber-dim {
    background-color: var(--amber-dim) !important;
}
.bg-approve {
    background-color: var(--approve) !important;
}
.bg-background {
    background-color: hsl(var(--background)) !important;
}
.bg-background\\/40 {
    background-color: hsl(var(--background) / 0.4) !important;
}
.bg-background\\/45 {
    background-color: hsl(var(--background) / 0.45) !important;
}
.bg-background\\/50 {
    background-color: hsl(var(--background) / 0.5) !important;
}
.bg-background\\/60 {
    background-color: hsl(var(--background) / 0.6) !important;
}
.bg-background\\/95 {
    background-color: hsl(var(--background) / 0.95) !important;
}
.bg-black\\/50 {
    background-color: rgb(0 0 0 / 0.5) !important;
}
.bg-black\\/80 {
    background-color: rgb(0 0 0 / 0.8) !important;
}
.bg-blue-400\\/10 {
    background-color: rgb(96 165 250 / 0.1) !important;
}
.bg-border {
    background-color: hsl(var(--border)) !important;
}
.bg-card {
    background-color: hsl(var(--card)) !important;
}
.bg-card\\/40 {
    background-color: hsl(var(--card) / 0.4) !important;
}
.bg-card\\/60 {
    background-color: hsl(var(--card) / 0.6) !important;
}
.bg-decline {
    background-color: var(--decline) !important;
}
.bg-destructive {
    background-color: hsl(var(--destructive)) !important;
}
.bg-destructive\\/10 {
    background-color: hsl(var(--destructive) / 0.1) !important;
}
.bg-destructive\\/15 {
    background-color: hsl(var(--destructive) / 0.15) !important;
}
.bg-destructive\\/5 {
    background-color: hsl(var(--destructive) / 0.05) !important;
}
.bg-foreground {
    background-color: hsl(var(--foreground)) !important;
}
.bg-foreground\\/5 {
    background-color: hsl(var(--foreground) / 0.05) !important;
}
.bg-muted {
    background-color: hsl(var(--muted)) !important;
}
.bg-muted-foreground\\/50 {
    background-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.bg-muted\\/10 {
    background-color: hsl(var(--muted) / 0.1) !important;
}
.bg-muted\\/20 {
    background-color: hsl(var(--muted) / 0.2) !important;
}
.bg-muted\\/30 {
    background-color: hsl(var(--muted) / 0.3) !important;
}
.bg-muted\\/40 {
    background-color: hsl(var(--muted) / 0.4) !important;
}
.bg-muted\\/50 {
    background-color: hsl(var(--muted) / 0.5) !important;
}
.bg-neutral-inactive {
    background-color: var(--neutral-inactive) !important;
}
.bg-neutral-inactive-dim {
    background-color: var(--neutral-inactive-dim) !important;
}
.bg-popover {
    background-color: hsl(var(--popover)) !important;
}
.bg-primary {
    background-color: hsl(var(--primary)) !important;
}
.bg-primary\\/10 {
    background-color: hsl(var(--primary) / 0.1) !important;
}
.bg-primary\\/15 {
    background-color: hsl(var(--primary) / 0.15) !important;
}
.bg-primary\\/35 {
    background-color: hsl(var(--primary) / 0.35) !important;
}
.bg-primary\\/5 {
    background-color: hsl(var(--primary) / 0.05) !important;
}
.bg-red-950\\/30 {
    background-color: rgb(69 10 10 / 0.3) !important;
}
.bg-secondary {
    background-color: hsl(var(--secondary)) !important;
}
.bg-secondary\\/20 {
    background-color: hsl(var(--secondary) / 0.2) !important;
}
.bg-secondary\\/30 {
    background-color: hsl(var(--secondary) / 0.3) !important;
}
.bg-secondary\\/40 {
    background-color: hsl(var(--secondary) / 0.4) !important;
}
.bg-secondary\\/50 {
    background-color: hsl(var(--secondary) / 0.5) !important;
}
.bg-secondary\\/60 {
    background-color: hsl(var(--secondary) / 0.6) !important;
}
.bg-success\\/10 {
    background-color: hsl(var(--success) / 0.1) !important;
}
.bg-success\\/15 {
    background-color: hsl(var(--success) / 0.15) !important;
}
.bg-success\\/20 {
    background-color: hsl(var(--success) / 0.2) !important;
}
.bg-success\\/5 {
    background-color: hsl(var(--success) / 0.05) !important;
}
.bg-transparent {
    background-color: transparent !important;
}
.bg-warning\\/10 {
    background-color: hsl(var(--warning) / 0.1) !important;
}
.bg-warning\\/15 {
    background-color: hsl(var(--warning) / 0.15) !important;
}
.bg-warning\\/5 {
    background-color: hsl(var(--warning) / 0.05) !important;
}
.fill-current {
    fill: currentColor !important;
}
.p-0 {
    padding: 0px !important;
}
.p-0\\.5 {
    padding: 0.125rem !important;
}
.p-1 {
    padding: 0.25rem !important;
}
.p-1\\.5 {
    padding: 0.375rem !important;
}
.p-2 {
    padding: 0.5rem !important;
}
.p-2\\.5 {
    padding: 0.625rem !important;
}
.p-3 {
    padding: 0.75rem !important;
}
.p-4 {
    padding: 1rem !important;
}
.p-5 {
    padding: 1.25rem !important;
}
.p-6 {
    padding: 1.5rem !important;
}
.p-8 {
    padding: 2rem !important;
}
.p-\\[1px\\] {
    padding: 1px !important;
}
.px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
.px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
}
.px-1\\.5 {
    padding-left: 0.375rem !important;
    padding-right: 0.375rem !important;
}
.px-10 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
}
.px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.px-2\\.5 {
    padding-left: 0.625rem !important;
    padding-right: 0.625rem !important;
}
.px-3 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
}
.px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}
.px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
}
.px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
}
.px-8 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
}
.py-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.py-0\\.5 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
}
.py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
.py-1\\.5 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
}
.py-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
}
.py-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
}
.py-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
}
.py-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
}
.py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.py-2\\.5 {
    padding-top: 0.625rem !important;
    padding-bottom: 0.625rem !important;
}
.py-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
}
.py-3\\.5 {
    padding-top: 0.875rem !important;
    padding-bottom: 0.875rem !important;
}
.py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.py-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
}
.py-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
}
.py-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
}
.pb-0 {
    padding-bottom: 0px !important;
}
.pb-0\\.5 {
    padding-bottom: 0.125rem !important;
}
.pb-16 {
    padding-bottom: 4rem !important;
}
.pb-2 {
    padding-bottom: 0.5rem !important;
}
.pb-24 {
    padding-bottom: 6rem !important;
}
.pb-3 {
    padding-bottom: 0.75rem !important;
}
.pb-4 {
    padding-bottom: 1rem !important;
}
.pb-6 {
    padding-bottom: 1.5rem !important;
}
.pb-7 {
    padding-bottom: 1.75rem !important;
}
.pb-8 {
    padding-bottom: 2rem !important;
}
.pb-\\[80px\\] {
    padding-bottom: 80px !important;
}
.pe-4 {
    padding-inline-end: 1rem !important;
}
.pl-12 {
    padding-left: 3rem !important;
}
.pl-2\\.5 {
    padding-left: 0.625rem !important;
}
.pl-3 {
    padding-left: 0.75rem !important;
}
.pl-4 {
    padding-left: 1rem !important;
}
.pl-40 {
    padding-left: 10rem !important;
}
.pl-6 {
    padding-left: 1.5rem !important;
}
.pl-7 {
    padding-left: 1.75rem !important;
}
.pl-8 {
    padding-left: 2rem !important;
}
.pr-0 {
    padding-right: 0px !important;
}
.pr-1 {
    padding-right: 0.25rem !important;
}
.pr-2 {
    padding-right: 0.5rem !important;
}
.pr-2\\.5 {
    padding-right: 0.625rem !important;
}
.pr-3 {
    padding-right: 0.75rem !important;
}
.pr-4 {
    padding-right: 1rem !important;
}
.pr-6 {
    padding-right: 1.5rem !important;
}
.pr-64 {
    padding-right: 16rem !important;
}
.pr-7 {
    padding-right: 1.75rem !important;
}
.pr-8 {
    padding-right: 2rem !important;
}
.ps-2 {
    padding-inline-start: 0.5rem !important;
}
.pt-0 {
    padding-top: 0px !important;
}
.pt-0\\.5 {
    padding-top: 0.125rem !important;
}
.pt-1 {
    padding-top: 0.25rem !important;
}
.pt-2 {
    padding-top: 0.5rem !important;
}
.pt-24 {
    padding-top: 6rem !important;
}
.pt-3 {
    padding-top: 0.75rem !important;
}
.pt-4 {
    padding-top: 1rem !important;
}
.pt-6 {
    padding-top: 1.5rem !important;
}
.pt-7 {
    padding-top: 1.75rem !important;
}
.pt-8 {
    padding-top: 2rem !important;
}
.pt-\\[110px\\] {
    padding-top: 110px !important;
}
.pt-\\[14px\\] {
    padding-top: 14px !important;
}
.pt-\\[175px\\] {
    padding-top: 175px !important;
}
.pt-\\[200px\\] {
    padding-top: 200px !important;
}
.pb-1\\.5 {
    padding-bottom: 0.375rem !important;
}
.pl-5 {
    padding-left: 1.25rem !important;
}
.text-left {
    text-align: left !important;
}
.text-center {
    text-align: center !important;
}
.text-right {
    text-align: right !important;
}
.text-end {
    text-align: end !important;
}
.align-top {
    vertical-align: top !important;
}
.align-middle {
    vertical-align: middle !important;
}
.align-bottom {
    vertical-align: bottom !important;
}
.align-super {
    vertical-align: super !important;
}
.font-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}
.text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
}
.text-3xl {
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
}
.text-5xl {
    font-size: 3rem !important;
    line-height: 1 !important;
}
.text-\\[0\\.6rem\\] {
    font-size: 0.6rem !important;
}
.text-\\[0\\.7rem\\] {
    font-size: 0.7rem !important;
}
.text-\\[0\\.8rem\\] {
    font-size: 0.8rem !important;
}
.text-\\[10px\\] {
    font-size: 10px !important;
}
.text-\\[11px\\] {
    font-size: 11px !important;
}
.text-\\[26px\\] {
    font-size: 26px !important;
}
.text-\\[9px\\] {
    font-size: 9px !important;
}
.text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
}
.text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
}
.text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}
.text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
}
.text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}
.font-bold {
    font-weight: 700 !important;
}
.font-medium {
    font-weight: 500 !important;
}
.font-normal {
    font-weight: 400 !important;
}
.font-semibold {
    font-weight: 600 !important;
}
.uppercase {
    text-transform: uppercase !important;
}
.lowercase {
    text-transform: lowercase !important;
}
.capitalize {
    text-transform: capitalize !important;
}
.normal-case {
    text-transform: none !important;
}
.italic {
    font-style: italic !important;
}
.ordinal {
    --tw-ordinal: ordinal !important;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.tabular-nums {
    --tw-numeric-spacing: tabular-nums !important;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.leading-5 {
    line-height: 1.25rem !important;
}
.leading-none {
    line-height: 1 !important;
}
.leading-relaxed {
    line-height: 1.625 !important;
}
.leading-snug {
    line-height: 1.375 !important;
}
.leading-tight {
    line-height: 1.25 !important;
}
.tracking-\\[0\\.08em\\] {
    letter-spacing: 0.08em !important;
}
.tracking-\\[0\\.12em\\] {
    letter-spacing: 0.12em !important;
}
.tracking-\\[0\\.14em\\] {
    letter-spacing: 0.14em !important;
}
.tracking-\\[0\\.15em\\] {
    letter-spacing: 0.15em !important;
}
.tracking-\\[0\\.16em\\] {
    letter-spacing: 0.16em !important;
}
.tracking-\\[0\\.18em\\] {
    letter-spacing: 0.18em !important;
}
.tracking-\\[0\\.1em\\] {
    letter-spacing: 0.1em !important;
}
.tracking-normal {
    letter-spacing: 0em !important;
}
.tracking-tight {
    letter-spacing: -0.025em !important;
}
.tracking-wide {
    letter-spacing: 0.025em !important;
}
.tracking-wider {
    letter-spacing: 0.05em !important;
}
.tracking-widest {
    letter-spacing: 0.1em !important;
}
.\\!text-primary {
    color: hsl(var(--primary)) !important;
}
.text-\\[color\\:var\\(--approve\\)\\] {
    color: var(--approve) !important;
}
.text-\\[color\\:var\\(--colorYellow\\)\\] {
    color: var(--colorYellow) !important;
}
.text-\\[color\\:var\\(--decline\\)\\] {
    color: var(--decline) !important;
}
.text-\\[hsl\\(30\\2c 9\\%\\2c 95\\%\\)\\] {
    --tw-text-opacity: 1 !important;
    color: hsl(30 9% 95% / var(--tw-text-opacity, 1)) !important;
}
.text-\\[hsl\\(30\\2c 9\\%\\2c 95\\%\\)\\]\\/70 {
    color: hsl(30 9% 95% / 0.7) !important;
}
.text-accent-foreground {
    color: hsl(var(--accent-foreground)) !important;
}
.text-amber {
    color: var(--amber) !important;
}
.text-approve {
    color: var(--approve) !important;
}
.text-background {
    color: hsl(var(--background)) !important;
}
.text-black {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-400 {
    --tw-text-opacity: 1 !important;
    color: rgb(96 165 250 / var(--tw-text-opacity, 1)) !important;
}
.text-card-foreground {
    color: hsl(var(--card-foreground)) !important;
}
.text-current {
    color: currentColor !important;
}
.text-decline {
    color: var(--decline) !important;
}
.text-destructive {
    color: hsl(var(--destructive)) !important;
}
.text-destructive-foreground {
    color: hsl(var(--destructive-foreground)) !important;
}
.text-foreground {
    color: hsl(var(--foreground)) !important;
}
.text-foreground\\/50 {
    color: hsl(var(--foreground) / 0.5) !important;
}
.text-foreground\\/60 {
    color: hsl(var(--foreground) / 0.6) !important;
}
.text-foreground\\/70 {
    color: hsl(var(--foreground) / 0.7) !important;
}
.text-foreground\\/75 {
    color: hsl(var(--foreground) / 0.75) !important;
}
.text-foreground\\/80 {
    color: hsl(var(--foreground) / 0.8) !important;
}
.text-foreground\\/85 {
    color: hsl(var(--foreground) / 0.85) !important;
}
.text-foreground\\/90 {
    color: hsl(var(--foreground) / 0.9) !important;
}
.text-muted-foreground {
    color: hsl(var(--muted-foreground)) !important;
}
.text-muted-foreground\\/60 {
    color: hsl(var(--muted-foreground) / 0.6) !important;
}
.text-muted-foreground\\/70 {
    color: hsl(var(--muted-foreground) / 0.7) !important;
}
.text-neutral-inactive {
    color: var(--neutral-inactive) !important;
}
.text-popover-foreground {
    color: hsl(var(--popover-foreground)) !important;
}
.text-primary {
    color: hsl(var(--primary)) !important;
}
.text-primary-foreground {
    color: hsl(var(--primary-foreground)) !important;
}
.text-red-300 {
    --tw-text-opacity: 1 !important;
    color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}
.text-red-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.text-secondary-foreground {
    color: hsl(var(--secondary-foreground)) !important;
}
.text-success {
    color: hsl(var(--success)) !important;
}
.text-warning {
    color: hsl(var(--warning)) !important;
}
.text-white {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.underline {
    text-decoration-line: underline !important;
}
.line-through {
    text-decoration-line: line-through !important;
}
.decoration-border {
    text-decoration-color: hsl(var(--border)) !important;
}
.decoration-muted-foreground\\/60 {
    text-decoration-color: hsl(var(--muted-foreground) / 0.6) !important;
}
.decoration-dotted {
    text-decoration-style: dotted !important;
}
.underline-offset-2 {
    text-underline-offset: 2px !important;
}
.underline-offset-4 {
    text-underline-offset: 4px !important;
}
.accent-\\[var\\(--primary\\)\\] {
    accent-color: var(--primary) !important;
}
.accent-primary {
    accent-color: hsl(var(--primary)) !important;
}
.opacity-0 {
    opacity: 0 !important;
}
.opacity-100 {
    opacity: 1 !important;
}
.opacity-40 {
    opacity: 0.4 !important;
}
.opacity-50 {
    opacity: 0.5 !important;
}
.opacity-55 {
    opacity: 0.55 !important;
}
.opacity-60 {
    opacity: 0.6 !important;
}
.opacity-70 {
    opacity: 0.7 !important;
}
.opacity-80 {
    opacity: 0.8 !important;
}
.opacity-90 {
    opacity: 0.9 !important;
}
.shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.outline {
    outline-style: solid !important;
}
.outline-1 {
    outline-width: 1px !important;
}
.outline-primary {
    outline-color: hsl(var(--primary)) !important;
}
.ring-0 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-1 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-background {
    --tw-ring-color: hsl(var(--background)) !important;
}
.ring-primary {
    --tw-ring-color: hsl(var(--primary)) !important;
}
.ring-ring {
    --tw-ring-color: hsl(var(--ring)) !important;
}
.ring-offset-background {
    --tw-ring-offset-color: hsl(var(--background)) !important;
}
.grayscale {
    --tw-grayscale: grayscale(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.invert {
    --tw-invert: invert(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.sepia {
    --tw-sepia: sepia(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-xl {
    --tw-backdrop-blur: blur(24px) !important;
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-saturate-150 {
    --tw-backdrop-saturate: saturate(1.5) !important;
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-all {
    transition-property: all !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-opacity {
    transition-property: opacity !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-transform {
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.duration-1000 {
    transition-duration: 1000ms !important;
}
.duration-150 {
    transition-duration: 150ms !important;
}
.duration-200 {
    transition-duration: 200ms !important;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
@keyframes enter {
    from {
        opacity: var(--tw-enter-opacity, 1);
        transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
    }
}
@keyframes exit {
    to {
        opacity: var(--tw-exit-opacity, 1);
        transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
    }
}
.animate-in {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}
.fade-in-0 {
    --tw-enter-opacity: 0 !important;
}
.fade-in-80 {
    --tw-enter-opacity: 0.8 !important;
}
.zoom-in-95 {
    --tw-enter-scale: .95 !important;
}
.duration-1000 {
    animation-duration: 1000ms !important;
}
.duration-150 {
    animation-duration: 150ms !important;
}
.duration-200 {
    animation-duration: 200ms !important;
}
.ease-in-out {
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.running {
    animation-play-state: running !important;
}
.\\[color-scheme\\:dark\\] {
    color-scheme: dark !important;
}
.\\[grid-template-rows\\:subgrid\\] {
    grid-template-rows: subgrid !important;
}

/* Radix components (Dialog, Sheet, Popover, Select, Dropdown, Tooltip, Toast)
   render their content through a portal directly into <body>, outside
   .portfolio-risk-concentration-theme entirely. Form elements don't inherit
   \`color\` from an ancestor by default per the browser's own UA stylesheet, so
   the .theme-scoped preflight reset further down never reaches them — they
   fall back to plain black text. Fix that specifically, scoped to the root
   class (which does wrap portal content, since it's set on <html>). */
html.portfolio-risk-concentration-root button,
html.portfolio-risk-concentration-root input,
html.portfolio-risk-concentration-root optgroup,
html.portfolio-risk-concentration-root select,
html.portfolio-risk-concentration-root textarea {
  color: hsl(var(--foreground));
}

html.portfolio-risk-concentration-root,
html.portfolio-risk-concentration-root *,
.portfolio-risk-concentration-theme,
.portfolio-risk-concentration-theme * {
  --background: 218 30% 8% !important;
  --foreground: 30 9% 95% !important;

  --card: 216 11% 15% !important;
  --card-foreground: 30 9% 95% !important;

  --popover: 216 11% 15% !important;
  --popover-foreground: 30 9% 95% !important;

  --primary: 33 98% 58% !important;
  --primary-foreground: 218 22% 13% !important;

  --secondary: 216 11% 18% !important;
  --secondary-foreground: 30 9% 90% !important;

  --muted: 216 11% 20% !important;
  --muted-foreground: 0 0% 49% !important;

  --accent: 33 50% 20% !important;
  --accent-foreground: 33 98% 58% !important;

  --destructive: 0 72% 51% !important;
  --destructive-foreground: 0 0% 100% !important;

  --success: 142 70% 45% !important;
  --success-foreground: 0 0% 100% !important;

  --warning: 45 93% 47% !important;
  --warning-foreground: 218 22% 13% !important;

  --border: 216 11% 22% !important;
  --input: 216 11% 18% !important;
  --ring: 33 98% 58% !important;

  --radius: 0rem !important;

  --sidebar-background: 218 22% 11% !important;
  --sidebar-foreground: 30 9% 90% !important;
  --sidebar-primary: 33 98% 58% !important;
  --sidebar-primary-foreground: 218 22% 13% !important;
  --sidebar-accent: 216 11% 16% !important;
  --sidebar-accent-foreground: 30 9% 95% !important;
  --sidebar-border: 216 11% 22% !important;
  --sidebar-ring: 33 98% 58% !important;

  --chart-1: 33 98% 58% !important;
  --chart-2: 173 80% 40% !important;
  --chart-3: 280 65% 60% !important;
  --chart-4: 45 93% 47% !important;
  --chart-5: 0 72% 51% !important;

  /* New tokens — full color values (tailwind.config.js references these as
     var(--amber) directly, not hsl(var(--amber)), so they must be complete
     color functions, not bare HSL triples like the tokens above). */
  --amber: hsl(33 98% 58%) !important;
  --amber-dim: hsl(33 98% 58% / 0.15) !important;
  --approve: hsl(142 70% 45%) !important;
  --decline: hsl(0 72% 51%) !important;
  --bar-muted: hsl(216 11% 45%) !important;
}

/* Custom scrollbar - scoped */
.portfolio-risk-concentration-theme ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.portfolio-risk-concentration-theme ::-webkit-scrollbar-track {
  background-color: hsl(var(--background));
}

.portfolio-risk-concentration-theme ::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.3);
}

.portfolio-risk-concentration-theme ::-webkit-scrollbar-thumb:hover {
  background-color: hsl(var(--muted-foreground) / 0.5);
}

/* Hide platform-ui elements when this feature is active */
html.portfolio-risk-concentration-root .leftnav,
html.portfolio-risk-concentration-root .main-wrapper,
html.portfolio-risk-concentration-root > body > header {
  display: none;
}

.portfolio-risk-concentration-theme header {
  display: block !important;
}

html.portfolio-risk-concentration-root,
html.portfolio-risk-concentration-root body {
  background-color: hsl(218 22% 13%) !important;
  margin: 0;
  padding: 0;
}

.file\\:border-0::file-selector-button {
    border-width: 0px !important;
}

.file\\:bg-transparent::file-selector-button {
    background-color: transparent !important;
}

.file\\:text-sm::file-selector-button {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}

.file\\:font-medium::file-selector-button {
    font-weight: 500 !important;
}

.file\\:text-foreground::file-selector-button {
    color: hsl(var(--foreground)) !important;
}

.placeholder\\:text-\\[hsl\\(0\\2c 0\\%\\2c 45\\%\\)\\]::placeholder {
    --tw-text-opacity: 1 !important;
    color: hsl(0 0% 45% / var(--tw-text-opacity, 1)) !important;
}

.placeholder\\:text-muted-foreground::placeholder {
    color: hsl(var(--muted-foreground)) !important;
}

.placeholder\\:text-muted-foreground\\/60::placeholder {
    color: hsl(var(--muted-foreground) / 0.6) !important;
}

.after\\:absolute::after {
    content: var(--tw-content) !important;
    position: absolute !important;
}

.after\\:inset-y-0::after {
    content: var(--tw-content) !important;
    top: 0px !important;
    bottom: 0px !important;
}

.after\\:left-1\\/2::after {
    content: var(--tw-content) !important;
    left: 50% !important;
}

.after\\:w-1::after {
    content: var(--tw-content) !important;
    width: 0.25rem !important;
}

.after\\:-translate-x-1\\/2::after {
    content: var(--tw-content) !important;
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.first\\:rounded-l-md:first-child {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.first\\:border-l:first-child {
    border-left-width: 1px !important;
}

.first\\:border-t-0:first-child {
    border-top-width: 0px !important;
}

.last\\:rounded-r-md:last-child {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

.last\\:border-0:last-child {
    border-width: 0px !important;
}

.last\\:border-b-0:last-child {
    border-bottom-width: 0px !important;
}

.last\\:border-r-0:last-child {
    border-right-width: 0px !important;
}

.focus-within\\:relative:focus-within {
    position: relative !important;
}

.focus-within\\:z-20:focus-within {
    z-index: 20 !important;
}

.hover\\:border-amber:hover {
    border-color: var(--amber) !important;
}

.hover\\:border-blue-400:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-destructive:hover {
    border-color: hsl(var(--destructive)) !important;
}

.hover\\:border-foreground:hover {
    border-color: hsl(var(--foreground)) !important;
}

.hover\\:border-primary:hover {
    border-color: hsl(var(--primary)) !important;
}

.hover\\:border-primary\\/40:hover {
    border-color: hsl(var(--primary) / 0.4) !important;
}

.hover\\:border-primary\\/50:hover {
    border-color: hsl(var(--primary) / 0.5) !important;
}

.hover\\:border-primary\\/60:hover {
    border-color: hsl(var(--primary) / 0.6) !important;
}

.hover\\:border-secondary-foreground\\/60:hover {
    border-color: hsl(var(--secondary-foreground) / 0.6) !important;
}

.hover\\:border-success:hover {
    border-color: hsl(var(--success)) !important;
}

.hover\\:bg-accent:hover {
    background-color: hsl(var(--accent)) !important;
}

.hover\\:bg-accent\\/80:hover {
    background-color: hsl(var(--accent) / 0.8) !important;
}

.hover\\:bg-amber:hover {
    background-color: var(--amber) !important;
}

.hover\\:bg-amber-dim:hover {
    background-color: var(--amber-dim) !important;
}

.hover\\:bg-blue-400:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-destructive:hover {
    background-color: hsl(var(--destructive)) !important;
}

.hover\\:bg-destructive\\/80:hover {
    background-color: hsl(var(--destructive) / 0.8) !important;
}

.hover\\:bg-destructive\\/90:hover {
    background-color: hsl(var(--destructive) / 0.9) !important;
}

.hover\\:bg-foreground:hover {
    background-color: hsl(var(--foreground)) !important;
}

.hover\\:bg-muted:hover {
    background-color: hsl(var(--muted)) !important;
}

.hover\\:bg-muted\\/20:hover {
    background-color: hsl(var(--muted) / 0.2) !important;
}

.hover\\:bg-muted\\/30:hover {
    background-color: hsl(var(--muted) / 0.3) !important;
}

.hover\\:bg-muted\\/40:hover {
    background-color: hsl(var(--muted) / 0.4) !important;
}

.hover\\:bg-muted\\/50:hover {
    background-color: hsl(var(--muted) / 0.5) !important;
}

.hover\\:bg-muted\\/60:hover {
    background-color: hsl(var(--muted) / 0.6) !important;
}

.hover\\:bg-primary:hover {
    background-color: hsl(var(--primary)) !important;
}

.hover\\:bg-primary\\/20:hover {
    background-color: hsl(var(--primary) / 0.2) !important;
}

.hover\\:bg-primary\\/80:hover {
    background-color: hsl(var(--primary) / 0.8) !important;
}

.hover\\:bg-primary\\/90:hover {
    background-color: hsl(var(--primary) / 0.9) !important;
}

.hover\\:bg-secondary:hover {
    background-color: hsl(var(--secondary)) !important;
}

.hover\\:bg-secondary\\/40:hover {
    background-color: hsl(var(--secondary) / 0.4) !important;
}

.hover\\:bg-secondary\\/50:hover {
    background-color: hsl(var(--secondary) / 0.5) !important;
}

.hover\\:bg-secondary\\/60:hover {
    background-color: hsl(var(--secondary) / 0.6) !important;
}

.hover\\:bg-secondary\\/80:hover {
    background-color: hsl(var(--secondary) / 0.8) !important;
}

.hover\\:bg-success:hover {
    background-color: hsl(var(--success)) !important;
}

.hover\\:bg-transparent:hover {
    background-color: transparent !important;
}

.hover\\:text-accent-foreground:hover {
    color: hsl(var(--accent-foreground)) !important;
}

.hover\\:text-amber:hover {
    color: var(--amber) !important;
}

.hover\\:text-background:hover {
    color: hsl(var(--background)) !important;
}

.hover\\:text-destructive:hover {
    color: hsl(var(--destructive)) !important;
}

.hover\\:text-destructive-foreground:hover {
    color: hsl(var(--destructive-foreground)) !important;
}

.hover\\:text-foreground:hover {
    color: hsl(var(--foreground)) !important;
}

.hover\\:text-muted-foreground:hover {
    color: hsl(var(--muted-foreground)) !important;
}

.hover\\:text-primary:hover {
    color: hsl(var(--primary)) !important;
}

.hover\\:text-primary-foreground:hover {
    color: hsl(var(--primary-foreground)) !important;
}

.hover\\:text-secondary-foreground:hover {
    color: hsl(var(--secondary-foreground)) !important;
}

.hover\\:text-success-foreground:hover {
    color: hsl(var(--success-foreground)) !important;
}

.hover\\:text-white:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:underline:hover {
    text-decoration-line: underline !important;
}

.hover\\:no-underline:hover {
    text-decoration-line: none !important;
}

.hover\\:opacity-100:hover {
    opacity: 1 !important;
}

.hover\\:opacity-80:hover {
    opacity: 0.8 !important;
}

.hover\\:ring-1:hover {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:border-amber:focus {
    border-color: var(--amber) !important;
}

.focus\\:bg-accent:focus {
    background-color: hsl(var(--accent)) !important;
}

.focus\\:bg-primary:focus {
    background-color: hsl(var(--primary)) !important;
}

.focus\\:bg-secondary\\/40:focus {
    background-color: hsl(var(--secondary) / 0.4) !important;
}

.focus\\:text-accent-foreground:focus {
    color: hsl(var(--accent-foreground)) !important;
}

.focus\\:text-primary-foreground:focus {
    color: hsl(var(--primary-foreground)) !important;
}

.focus\\:opacity-100:focus {
    opacity: 1 !important;
}

.focus\\:outline-none:focus {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.focus\\:ring-0:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-1:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-primary:focus {
    --tw-ring-color: hsl(var(--primary)) !important;
}

.focus\\:ring-ring:focus {
    --tw-ring-color: hsl(var(--ring)) !important;
}

.focus\\:ring-white\\/40:focus {
    --tw-ring-color: rgb(255 255 255 / 0.4) !important;
}

.focus\\:ring-offset-0:focus {
    --tw-ring-offset-width: 0px !important;
}

.focus\\:ring-offset-2:focus {
    --tw-ring-offset-width: 2px !important;
}

.focus\\:ring-offset-background:focus {
    --tw-ring-offset-color: hsl(var(--background)) !important;
}

.focus-visible\\:border-amber:focus-visible {
    border-color: var(--amber) !important;
}

.focus-visible\\:text-amber:focus-visible {
    color: var(--amber) !important;
}

.focus-visible\\:outline-none:focus-visible {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.focus-visible\\:ring-0:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-1:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-2:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus-visible\\:ring-primary:focus-visible {
    --tw-ring-color: hsl(var(--primary)) !important;
}

.focus-visible\\:ring-ring:focus-visible {
    --tw-ring-color: hsl(var(--ring)) !important;
}

.focus-visible\\:ring-offset-0:focus-visible {
    --tw-ring-offset-width: 0px !important;
}

.focus-visible\\:ring-offset-1:focus-visible {
    --tw-ring-offset-width: 1px !important;
}

.focus-visible\\:ring-offset-2:focus-visible {
    --tw-ring-offset-width: 2px !important;
}

.focus-visible\\:ring-offset-background:focus-visible {
    --tw-ring-offset-color: hsl(var(--background)) !important;
}

.active\\:cursor-grabbing:active {
    cursor: grabbing !important;
}

.disabled\\:pointer-events-none:disabled {
    pointer-events: none !important;
}

.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed !important;
}

.disabled\\:bg-amber-dim:disabled {
    background-color: var(--amber-dim) !important;
}

.disabled\\:text-muted-foreground:disabled {
    color: hsl(var(--muted-foreground)) !important;
}

.disabled\\:opacity-100:disabled {
    opacity: 1 !important;
}

.disabled\\:opacity-25:disabled {
    opacity: 0.25 !important;
}

.disabled\\:opacity-30:disabled {
    opacity: 0.3 !important;
}

.disabled\\:opacity-40:disabled {
    opacity: 0.4 !important;
}

.disabled\\:opacity-50:disabled {
    opacity: 0.5 !important;
}

.group:hover .group-hover\\:opacity-100 {
    opacity: 1 !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
    border-color: hsl(var(--muted) / 0.4) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border {
    border-color: hsl(var(--border)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted {
    background-color: hsl(var(--muted)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary {
    background-color: hsl(var(--primary)) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background {
    background-color: hsl(var(--background)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
    --tw-text-opacity: 1 !important;
    color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground {
    color: hsl(var(--muted-foreground)) !important;
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground {
    color: hsl(var(--primary-foreground)) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground {
    color: hsl(var(--foreground)) !important;
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
    border-color: hsl(var(--destructive) / 0.3) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
    background-color: hsl(var(--destructive)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
    color: hsl(var(--destructive-foreground)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(254 242 242 / var(--tw-text-opacity, 1)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
    --tw-ring-color: hsl(var(--destructive)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1)) !important;
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
    --tw-ring-offset-color: #dc2626 !important;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
    cursor: not-allowed !important;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
    opacity: 0.7 !important;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
    opacity: 0.5 !important;
}

.aria-selected\\:bg-accent[aria-selected="true"] {
    background-color: hsl(var(--accent)) !important;
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
    background-color: hsl(var(--accent) / 0.5) !important;
}

.aria-selected\\:text-accent-foreground[aria-selected="true"] {
    color: hsl(var(--accent-foreground)) !important;
}

.aria-selected\\:text-muted-foreground[aria-selected="true"] {
    color: hsl(var(--muted-foreground)) !important;
}

.aria-selected\\:opacity-100[aria-selected="true"] {
    opacity: 1 !important;
}

.aria-selected\\:opacity-30[aria-selected="true"] {
    opacity: 0.3 !important;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
    pointer-events: none !important;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
    pointer-events: none !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
    height: 1px !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
    width: 100% !important;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
    --tw-translate-y: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
    --tw-translate-x: -0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
    --tw-translate-x: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
    --tw-translate-y: -0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"] {
    --tw-translate-x: 1.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
    --tw-translate-x: var(--radix-toast-swipe-end-x) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
    --tw-translate-x: var(--radix-toast-swipe-move-x) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

@keyframes accordion-up {
    from {
        height: var(--radix-accordion-content-height);
    }
    to {
        height: 0;
    }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
    animation: accordion-up 0.2s ease-out !important;
}

@keyframes accordion-down {
    from {
        height: 0;
    }
    to {
        height: var(--radix-accordion-content-height);
    }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
    animation: accordion-down 0.2s ease-out !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
    flex-direction: column !important;
}

.data-\\[active\\]\\:bg-accent\\/50[data-active] {
    background-color: hsl(var(--accent) / 0.5) !important;
}

.data-\\[selected\\=\\'true\\'\\]\\:bg-accent[data-selected='true'] {
    background-color: hsl(var(--accent)) !important;
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
    background-color: hsl(var(--background)) !important;
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
    background-color: hsl(var(--primary)) !important;
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
    background-color: hsl(var(--accent)) !important;
}

.data-\\[state\\=on\\]\\:bg-primary[data-state="on"] {
    background-color: hsl(var(--primary)) !important;
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
    background-color: hsl(var(--accent)) !important;
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
    background-color: hsl(var(--accent) / 0.5) !important;
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
    background-color: hsl(var(--secondary)) !important;
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
    background-color: hsl(var(--muted)) !important;
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
    background-color: hsl(var(--input)) !important;
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
    color: hsl(var(--accent-foreground)) !important;
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
    color: hsl(var(--foreground)) !important;
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
    color: hsl(var(--primary-foreground)) !important;
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
    color: hsl(var(--accent-foreground)) !important;
}

.data-\\[state\\=on\\]\\:text-primary-foreground[data-state="on"] {
    color: hsl(var(--primary-foreground)) !important;
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
    color: hsl(var(--accent-foreground)) !important;
}

.data-\\[state\\=open\\]\\:text-white[data-state="open"] {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
    opacity: 0.5 !important;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
    opacity: 0.5 !important;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
    transition-property: none !important;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
    transition-duration: 300ms !important;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
    transition-duration: 500ms !important;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
    --tw-enter-opacity: 0 !important;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
    --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
    --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
    --tw-exit-opacity: 0.8 !important;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
    --tw-exit-opacity: 0 !important;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
    --tw-enter-opacity: 0 !important;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
    --tw-enter-opacity: 0 !important;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
    --tw-exit-scale: .95 !important;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
    --tw-enter-scale: .9 !important;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
    --tw-enter-scale: .95 !important;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
    --tw-enter-translate-x: 13rem !important;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
    --tw-enter-translate-x: -13rem !important;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
    --tw-exit-translate-x: 13rem !important;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
    --tw-exit-translate-x: -13rem !important;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
    --tw-enter-translate-y: -0.5rem !important;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
    --tw-enter-translate-x: 0.5rem !important;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
    --tw-enter-translate-x: -0.5rem !important;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
    --tw-enter-translate-y: 0.5rem !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
    --tw-exit-translate-y: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
    --tw-exit-translate-x: -100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
    --tw-exit-translate-x: -50% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
    --tw-exit-translate-x: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
    --tw-exit-translate-x: 100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
    --tw-exit-translate-y: -100% !important;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
    --tw-exit-translate-y: -48% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
    --tw-enter-translate-y: 100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
    --tw-enter-translate-x: -100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
    --tw-enter-translate-x: -50% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
    --tw-enter-translate-x: 100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
    --tw-enter-translate-y: -100% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
    --tw-enter-translate-y: -48% !important;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
    --tw-enter-translate-y: -100% !important;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
    animation-duration: 300ms !important;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
    animation-duration: 500ms !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    left: 0px !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    height: 0.25rem !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    width: 100% !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
    content: var(--tw-content) !important;
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.data-\\[state\\=on\\]\\:hover\\:bg-primary:hover[data-state="on"] {
    background-color: hsl(var(--primary)) !important;
}

.data-\\[state\\=on\\]\\:hover\\:text-primary-foreground:hover[data-state="on"] {
    color: hsl(var(--primary-foreground)) !important;
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.dark\\:border-destructive:is(.dark *) {
    border-color: hsl(var(--destructive)) !important;
}

@media (min-width: 640px) {
    .sm\\:bottom-0 {
        bottom: 0px !important;
    }
    .sm\\:right-0 {
        right: 0px !important;
    }
    .sm\\:top-auto {
        top: auto !important;
    }
    .sm\\:col-span-2 {
        grid-column: span 2 / span 2 !important;
    }
    .sm\\:mt-0 {
        margin-top: 0px !important;
    }
    .sm\\:max-w-2xl {
        max-width: 42rem !important;
    }
    .sm\\:max-w-3xl {
        max-width: 48rem !important;
    }
    .sm\\:max-w-4xl {
        max-width: 56rem !important;
    }
    .sm\\:max-w-\\[520px\\] {
        max-width: 520px !important;
    }
    .sm\\:max-w-lg {
        max-width: 32rem !important;
    }
    .sm\\:max-w-md {
        max-width: 28rem !important;
    }
    .sm\\:max-w-sm {
        max-width: 24rem !important;
    }
    .sm\\:max-w-xl {
        max-width: 36rem !important;
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .sm\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .sm\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .sm\\:grid-cols-\\[150px_1fr_auto_auto_auto\\] {
        grid-template-columns: 150px 1fr auto auto auto !important;
    }
    .sm\\:grid-cols-\\[150px_150px_1fr_auto\\] {
        grid-template-columns: 150px 150px 1fr auto !important;
    }
    .sm\\:grid-cols-\\[150px_1fr_auto\\] {
        grid-template-columns: 150px 1fr auto !important;
    }
    .sm\\:flex-row {
        flex-direction: row !important;
    }
    .sm\\:flex-col {
        flex-direction: column !important;
    }
    .sm\\:items-end {
        align-items: flex-end !important;
    }
    .sm\\:items-center {
        align-items: center !important;
    }
    .sm\\:justify-end {
        justify-content: flex-end !important;
    }
    .sm\\:justify-between {
        justify-content: space-between !important;
    }
    .sm\\:gap-2\\.5 {
        gap: 0.625rem !important;
    }
    .sm\\:gap-3 {
        gap: 0.75rem !important;
    }
    .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0 !important;
        margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
        margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
    }
    .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0 !important;
        margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
        margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
    }
    .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0 !important;
        margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
        margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
    }
    .sm\\:rounded-lg {
        border-radius: 0px !important;
    }
    .sm\\:px-6 {
        padding-left: 1.5rem !important;
        padding-right: 1.5rem !important;
    }
    .sm\\:text-left {
        text-align: left !important;
    }
    .sm\\:text-3xl {
        font-size: 1.875rem !important;
        line-height: 2.25rem !important;
    }
    .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
        --tw-enter-translate-y: 100% !important;
    }
}

@media (min-width: 768px) {
    .md\\:absolute {
        position: absolute !important;
    }
    .md\\:col-span-1 {
        grid-column: span 1 / span 1 !important;
    }
    .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
        width: var(--radix-navigation-menu-viewport-width) !important;
    }
    .md\\:w-auto {
        width: auto !important;
    }
    .md\\:max-w-\\[420px\\] {
        max-width: 420px !important;
    }
    .md\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .md\\:p-8 {
        padding: 2rem !important;
    }
    .md\\:text-3xl {
        font-size: 1.875rem !important;
        line-height: 2.25rem !important;
    }
    .md\\:text-sm {
        font-size: 0.875rem !important;
        line-height: 1.25rem !important;
    }
}

@media (min-width: 1024px) {
    .lg\\:sticky {
        position: sticky !important;
    }
    .lg\\:top-\\[200px\\] {
        top: 200px !important;
    }
    .lg\\:order-none {
        order: 0 !important;
    }
    .lg\\:col-span-3 {
        grid-column: span 3 / span 3 !important;
    }
    .lg\\:col-span-5 {
        grid-column: span 5 / span 5 !important;
    }
    .lg\\:inline {
        display: inline !important;
    }
    .lg\\:max-h-\\[calc\\(100vh-220px\\)\\] {
        max-height: calc(100vh - 220px) !important;
    }
    .lg\\:auto-cols-fr {
        grid-auto-columns: minmax(0, 1fr) !important;
    }
    .lg\\:grid-flow-col {
        grid-auto-flow: column !important;
    }
    .lg\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-5 {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-\\[minmax\\(0\\2c 340px\\)_minmax\\(0\\2c 1fr\\)\\] {
        grid-template-columns: minmax(0,340px) minmax(0,1fr) !important;
    }
    .lg\\:grid-cols-none {
        grid-template-columns: none !important;
    }
    .lg\\:self-start {
        align-self: flex-start !important;
    }
    .lg\\:overflow-y-auto {
        overflow-y: auto !important;
    }
}

@media (min-width: 1280px) {
    .xl\\:col-span-2 {
        grid-column: span 2 / span 2 !important;
    }
    .xl\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .xl\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .xl\\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    }
}

.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:invert::-webkit-calendar-picker-indicator {
    --tw-invert: invert(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
    background-color: hsl(var(--accent)) !important;
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
    background-color: hsl(var(--accent) / 0.5) !important;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
    padding-right: 0px !important;
}

.\\[\\&\\>button\\:last-child\\]\\:text-white\\/70>button:last-child {
    color: rgb(255 255 255 / 0.7) !important;
}

.\\[\\&\\>button\\:last-child\\]\\:hover\\:text-white:hover>button:last-child {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&\\>button\\>svg\\]\\:h-5>button>svg {
    height: 1.25rem !important;
}

.\\[\\&\\>button\\>svg\\]\\:w-5>button>svg {
    width: 1.25rem !important;
}

.\\[\\&\\>button\\]\\:z-10>button {
    z-index: 10 !important;
}

.\\[\\&\\>button\\]\\:hidden>button {
    display: none !important;
}

.\\[\\&\\>button\\]\\:h-6>button {
    height: 1.5rem !important;
}

.\\[\\&\\>button\\]\\:w-6>button {
    width: 1.5rem !important;
}

.\\[\\&\\>button\\]\\:text-foreground\\/70>button {
    color: hsl(var(--foreground) / 0.7) !important;
}

.\\[\\&\\>button\\]\\:hover\\:text-foreground:hover>button {
    color: hsl(var(--foreground)) !important;
}

.\\[\\&\\>button_svg\\]\\:text-white>button svg {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&\\>div\\:last-child\\]\\:mt-3>div:last-child {
    margin-top: 0.75rem !important;
}

.\\[\\&\\>div\\]\\:hidden>div {
    display: none !important;
}

.\\[\\&\\>option\\]\\:bg-popover>option {
    background-color: hsl(var(--popover)) !important;
}

.\\[\\&\\>option\\]\\:text-foreground>option {
    color: hsl(var(--foreground)) !important;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
    --tw-translate-y: -3px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\>svg\\]\\:absolute>svg {
    position: absolute !important;
}

.\\[\\&\\>svg\\]\\:left-4>svg {
    left: 1rem !important;
}

.\\[\\&\\>svg\\]\\:top-4>svg {
    top: 1rem !important;
}

.\\[\\&\\>svg\\]\\:hidden>svg {
    display: none !important;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
    width: 0.875rem !important;
    height: 0.875rem !important;
}

.\\[\\&\\>svg\\]\\:h-2\\.5>svg {
    height: 0.625rem !important;
}

.\\[\\&\\>svg\\]\\:h-3>svg {
    height: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:w-2\\.5>svg {
    width: 0.625rem !important;
}

.\\[\\&\\>svg\\]\\:w-3>svg {
    width: 0.75rem !important;
}

.\\[\\&\\>svg\\]\\:\\!text-primary>svg {
    color: hsl(var(--primary)) !important;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg {
    color: hsl(var(--destructive)) !important;
}

.\\[\\&\\>svg\\]\\:text-foreground>svg {
    color: hsl(var(--foreground)) !important;
}

.\\[\\&\\>svg\\]\\:text-muted-foreground>svg {
    color: hsl(var(--muted-foreground)) !important;
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
    padding-left: 1.75rem !important;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
    border-bottom-width: 0px !important;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
    --tw-rotate: 90deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text {
    fill: hsl(var(--muted-foreground)) !important;
}

.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc'] {
    stroke: hsl(var(--border) / 0.5) !important;
}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor {
    stroke: hsl(var(--border)) !important;
}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff'] {
    stroke: transparent !important;
}

.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc'] {
    stroke: hsl(var(--border)) !important;
}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector {
    fill: hsl(var(--muted)) !important;
}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor {
    fill: hsl(var(--muted)) !important;
}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc'] {
    stroke: hsl(var(--border)) !important;
}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff'] {
    stroke: transparent !important;
}

.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
    font-weight: 500 !important;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
    color: hsl(var(--muted-foreground)) !important;
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
    padding-top: 0px !important;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
    height: 1.25rem !important;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
    width: 1.25rem !important;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
    height: 3rem !important;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
    height: 1.25rem !important;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
    width: 1.25rem !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:h-5 [role=slider] {
    height: 1.25rem !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:w-5 [role=slider] {
    width: 1.25rem !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:border-amber [role=slider] {
    border-color: var(--amber) !important;
}

.\\[\\&_\\[role\\=slider\\]\\]\\:bg-amber [role=slider] {
    background-color: var(--amber) !important;
}

.\\[\\&_h2\\]\\:text-xs h2 {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}

.\\[\\&_h2\\]\\:leading-snug h2 {
    line-height: 1.375 !important;
}

.\\[\\&_p\\]\\:leading-relaxed p {
    line-height: 1.625 !important;
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
    pointer-events: none !important;
}

.\\[\\&_svg\\]\\:size-4 svg {
    width: 1rem !important;
    height: 1rem !important;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
    flex-shrink: 0 !important;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
    border-width: 0px !important;
}

.\\[\\&_tr\\]\\:border-b tr {
    border-bottom-width: 1px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/portfolio-risk-concentration/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;4EAa4E;;AAE5E;;;;wDAIwD;AACxD;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AACd;IAAA,WAAoB;IAApB,kBAAoB;IAApB,iBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;QAAA;IAAoB;AAAA;AAoFlB;IACE,0DAA0D;IAC1D,iBAAiB;IACjB,wCAAwC;IACxC,6BAA6B;EAC/B;AAEA;;wEAEsE;AACtE;;;IAGE,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,gCAAgC;EAClC;AAEA;IACE,gBAAgB;IAChB,8BAA8B;IAE9B,WAAW;EACb;AAEA;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EACvB;AAEA;;IAEE,mBAAmB;EACrB;AAEA;;;;IAIE,+GAA+G;IAC/G,cAAc;EAChB;AAEA;IACE,cAAc;EAChB;AAEA;;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;AAEA;IACE,eAAe;EACjB;AAEA;IACE,WAAW;EACb;AAEA;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;AAEA;;;;;IAKE,oBAAoB;IACpB,8BAA8B;IAC9B,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,UAAU;EACZ;AAEA;;IAEE,oBAAoB;EACtB;AAEA;;;;IAIE,0BAA0B;IAC1B,6BAA6B;IAC7B,sBAAsB;EACxB;AAEA;IACE,aAAa;EACf;AAEA;IACE,gBAAgB;EAClB;AAEA;IACE,wBAAwB;EAC1B;AAEA;;IAEE,YAAY;EACd;AAEA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;AAEA;IACE,wBAAwB;EAC1B;AAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;AAEA;IACE,kBAAkB;EACpB;AAEA;;;;;;;;;;;;;IAaE,SAAS;EACX;AAEA;IACE,SAAS;IACT,UAAU;EACZ;AAEA;IACE,UAAU;EACZ;AAEA;;;IAGE,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;AAEA;IACE,UAAU;EACZ;AAEA;IACE,gBAAgB;EAClB;AAEA;;IAEE,UAAU;IACV,mCAAmC;EACrC;AAEA;;IAEE,eAAe;EACjB;AAEA;IACE,eAAe;EACjB;AAEA;;;;;;;;IAQE,cAAc;IACd,sBAAsB;EACxB;AAEA;;IAEE,eAAe;IACf,YAAY;EACd;AAEA;IACE,aAAa;EACf;AAEA;;;;;;IAME,0DAA0D;IAC1D,gBAAgB;IAChB,wBAAwB;EAC1B;AAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AAEA;IACE,oBAAoB;EACtB;AA3TF;IAAA,6BAAmB;IAAnB,qBAAmB;IAAnB,sBAAmB;IAAnB,qBAAmB;IAAnB,uBAAmB;IAAnB,2BAAmB;IAAnB,iCAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oCAAmB;YAAnB;AAAmB;AAAnB;IAAA,mCAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,2EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,2EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB,6EAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2DAAmB;IAAnB,wEAAmB;IAAnB;AAAmB;AAAnB;IAAA,0FAAmB;IAAnB,8GAAmB;IAAnB;AAAmB;AAAnB;IAAA,wFAAmB;IAAnB,4GAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,2FAAmB;IAAnB,+GAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA,oCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,mKAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,0GAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,mCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;QAAA,kCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA,gCAAmB;IAAnB,oCAAmB;IAAnB,sCAAmB;IAAnB,oCAAmB;IAAnB,qCAAmB;IAAnB,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AAEnB;;;;;;sEAMsE;AACtE;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;EAIE,mCAAmC;EACnC,kCAAkC;;EAElC,8BAA8B;EAC9B,uCAAuC;;EAEvC,iCAAiC;EACjC,0CAA0C;;EAE1C,gCAAgC;EAChC,4CAA4C;;EAE5C,mCAAmC;EACnC,4CAA4C;;EAE5C,+BAA+B;EAC/B,uCAAuC;;EAEvC,+BAA+B;EAC/B,0CAA0C;;EAE1C,mCAAmC;EACnC,8CAA8C;;EAE9C,iCAAiC;EACjC,0CAA0C;;EAE1C,gCAAgC;EAChC,4CAA4C;;EAE5C,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;;EAE7B,yBAAyB;;EAEzB,4CAA4C;EAC5C,0CAA0C;EAC1C,wCAAwC;EACxC,oDAAoD;EACpD,wCAAwC;EACxC,iDAAiD;EACjD,wCAAwC;EACxC,qCAAqC;;EAErC,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;;EAE/B;;oEAEkE;EAClE,mCAAmC;EACnC,8CAA8C;EAC9C,sCAAsC;EACtC,oCAAoC;EACpC,wCAAwC;AAC1C;;AA8OA,8BAA8B;AAC9B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,0DAA0D;AAC1D;;;EAGE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6CAA6C;EAC7C,SAAS;EACT,UAAU;AACZ;;AAtXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,8BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA,mBAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA,iCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,uCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,iCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,6BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA,sHAuXA;IAvXA,oHAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,0FAuXA;IAvXA,8GAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,oCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,oCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,oCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,gCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,gCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,2DAuXA;IAvXA;AAuXA;;AAvXA;IAAA,4DAuXA;IAvXA;AAuXA;;AAvXA;IAAA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;AAAA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;AAAA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,qDAuXA;IAvXA,kEAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,gCAuXA;IAvXA,oCAuXA;IAvXA,sCAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,0CAuXA;IAvXA;AAuXA;;AAvXA;IAAA,gCAuXA;IAvXA,oCAuXA;IAvXA,sCAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,0CAuXA;IAvXA;AAuXA;;AAvXA;IAAA,gCAuXA;IAvXA,oCAuXA;IAvXA,sCAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,0CAuXA;IAvXA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,mCAuXA;IAvXA,oCAuXA;IAvXA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,mCAuXA;IAvXA,oCAuXA;IAvXA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,mCAuXA;IAvXA,oCAuXA;IAvXA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA,oCAuXA;IAvXA,qCAuXA;IAvXA,mCAuXA;IAvXA,oCAuXA;IAvXA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA,iCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,qCAuXA;IAvXA,gCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,8BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA,kCAuXA;QAvXA,iEAuXA;QAvXA;IAuXA;IAvXA;QAAA,kCAuXA;QAvXA,+DAuXA;QAvXA;IAuXA;IAvXA;QAAA,kCAuXA;QAvXA,sEAuXA;QAvXA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA,+BAuXA;QAvXA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA,8BAuXA;QAvXA;IAuXA;IAvXA;QAAA;IAuXA;AAAA;;AAvXA;IAAA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA,8BAuXA;QAvXA;IAuXA;IAvXA;QAAA,8BAuXA;QAvXA;IAuXA;AAAA;;AAvXA;IAAA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;AAAA;;AAvXA;IAAA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;IAvXA;QAAA;IAuXA;AAAA;;AAvXA;IAAA,oCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,sCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,uCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,uCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,2BAuXA;IAvXA,+BAuXA;IAvXA,uCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,iCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,0BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,6BAuXA;IAvXA;AAuXA;;AAvXA;IAAA,8BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,yCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA,gCAuXA;IAvXA;AAuXA;;AAvXA;IAAA,6BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA,+BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,6BAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA,sBAuXA;IAvXA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA;;AAvXA;IAAA;AAuXA","sourcesContent":["/* =======================================================================\n   PORTFOLIO RISK CONCENTRATION MODULE STYLES - SCOPED\n\n   All styles are scoped under .portfolio-risk-concentration-theme and\n   .portfolio-risk-concentration-root to prevent conflicts with platform-ui\n   styles.\n\n   Standard theme tokens reuse the same Athena dark palette as\n   UnderwritingEngineV2 (see assets/css/UnderwritingEngineV2/style.css) for\n   visual consistency across feature modules. The --amber/--amber-dim/\n   --approve/--decline/--bar-muted tokens are new — tailwind.config.js\n   already references them (colors.amber, colors.approve, etc.) but nothing\n   previously defined their actual values.\n   ======================================================================= */\n\n/* Required for @layer below to resolve — webpack's css-loader/postcss\n   pipeline processes each imported CSS file as its own unit, so @layer\n   needs its matching @tailwind directive present in THIS file even though\n   src/index.css already loads Tailwind globally (same reason\n   UnderwritingEngineV2/style.css includes these too). */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Radix components (Dialog, Sheet, Popover, Select, Dropdown, Tooltip, Toast)\n   render their content through a portal directly into <body>, outside\n   .portfolio-risk-concentration-theme entirely. Form elements don't inherit\n   `color` from an ancestor by default per the browser's own UA stylesheet, so\n   the .theme-scoped preflight reset further down never reaches them — they\n   fall back to plain black text. Fix that specifically, scoped to the root\n   class (which does wrap portal content, since it's set on <html>). */\nhtml.portfolio-risk-concentration-root button,\nhtml.portfolio-risk-concentration-root input,\nhtml.portfolio-risk-concentration-root optgroup,\nhtml.portfolio-risk-concentration-root select,\nhtml.portfolio-risk-concentration-root textarea {\n  color: hsl(var(--foreground));\n}\n\nhtml.portfolio-risk-concentration-root,\nhtml.portfolio-risk-concentration-root *,\n.portfolio-risk-concentration-theme,\n.portfolio-risk-concentration-theme * {\n  --background: 218 30% 8% !important;\n  --foreground: 30 9% 95% !important;\n\n  --card: 216 11% 15% !important;\n  --card-foreground: 30 9% 95% !important;\n\n  --popover: 216 11% 15% !important;\n  --popover-foreground: 30 9% 95% !important;\n\n  --primary: 33 98% 58% !important;\n  --primary-foreground: 218 22% 13% !important;\n\n  --secondary: 216 11% 18% !important;\n  --secondary-foreground: 30 9% 90% !important;\n\n  --muted: 216 11% 20% !important;\n  --muted-foreground: 0 0% 49% !important;\n\n  --accent: 33 50% 20% !important;\n  --accent-foreground: 33 98% 58% !important;\n\n  --destructive: 0 72% 51% !important;\n  --destructive-foreground: 0 0% 100% !important;\n\n  --success: 142 70% 45% !important;\n  --success-foreground: 0 0% 100% !important;\n\n  --warning: 45 93% 47% !important;\n  --warning-foreground: 218 22% 13% !important;\n\n  --border: 216 11% 22% !important;\n  --input: 216 11% 18% !important;\n  --ring: 33 98% 58% !important;\n\n  --radius: 0rem !important;\n\n  --sidebar-background: 218 22% 11% !important;\n  --sidebar-foreground: 30 9% 90% !important;\n  --sidebar-primary: 33 98% 58% !important;\n  --sidebar-primary-foreground: 218 22% 13% !important;\n  --sidebar-accent: 216 11% 16% !important;\n  --sidebar-accent-foreground: 30 9% 95% !important;\n  --sidebar-border: 216 11% 22% !important;\n  --sidebar-ring: 33 98% 58% !important;\n\n  --chart-1: 33 98% 58% !important;\n  --chart-2: 173 80% 40% !important;\n  --chart-3: 280 65% 60% !important;\n  --chart-4: 45 93% 47% !important;\n  --chart-5: 0 72% 51% !important;\n\n  /* New tokens — full color values (tailwind.config.js references these as\n     var(--amber) directly, not hsl(var(--amber)), so they must be complete\n     color functions, not bare HSL triples like the tokens above). */\n  --amber: hsl(33 98% 58%) !important;\n  --amber-dim: hsl(33 98% 58% / 0.15) !important;\n  --approve: hsl(142 70% 45%) !important;\n  --decline: hsl(0 72% 51%) !important;\n  --bar-muted: hsl(216 11% 45%) !important;\n}\n\n@layer components {\n  .portfolio-risk-concentration-theme {\n    font-family: 'Inter', system-ui, -apple-system, sans-serif;\n    min-height: 100vh;\n    background-color: hsl(var(--background));\n    color: hsl(var(--foreground));\n  }\n\n  /* Tailwind preflight is disabled globally (corePlugins.preflight: false in\n     tailwind.config.js) to avoid conflicting with Bootstrap. Re-apply just\n     the box-model/typography reset here, scoped to this feature only. */\n  .portfolio-risk-concentration-theme *,\n  .portfolio-risk-concentration-theme *::before,\n  .portfolio-risk-concentration-theme *::after {\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-color: hsl(var(--border));\n  }\n\n  .portfolio-risk-concentration-theme {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    -moz-tab-size: 4;\n    tab-size: 4;\n  }\n\n  .portfolio-risk-concentration-theme hr {\n    height: 0;\n    color: inherit;\n    border-top-width: 1px;\n  }\n\n  .portfolio-risk-concentration-theme b,\n  .portfolio-risk-concentration-theme strong {\n    font-weight: bolder;\n  }\n\n  .portfolio-risk-concentration-theme code,\n  .portfolio-risk-concentration-theme kbd,\n  .portfolio-risk-concentration-theme samp,\n  .portfolio-risk-concentration-theme pre {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 1em;\n  }\n\n  .portfolio-risk-concentration-theme small {\n    font-size: 80%;\n  }\n\n  .portfolio-risk-concentration-theme sub,\n  .portfolio-risk-concentration-theme sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  .portfolio-risk-concentration-theme sub {\n    bottom: -0.25em;\n  }\n\n  .portfolio-risk-concentration-theme sup {\n    top: -0.5em;\n  }\n\n  .portfolio-risk-concentration-theme table {\n    text-indent: 0;\n    border-color: inherit;\n    border-collapse: collapse;\n  }\n\n  .portfolio-risk-concentration-theme button,\n  .portfolio-risk-concentration-theme input,\n  .portfolio-risk-concentration-theme optgroup,\n  .portfolio-risk-concentration-theme select,\n  .portfolio-risk-concentration-theme textarea {\n    font-family: inherit;\n    font-feature-settings: inherit;\n    font-variation-settings: inherit;\n    font-size: 100%;\n    font-weight: inherit;\n    line-height: inherit;\n    color: inherit;\n    margin: 0;\n    padding: 0;\n  }\n\n  .portfolio-risk-concentration-theme button,\n  .portfolio-risk-concentration-theme select {\n    text-transform: none;\n  }\n\n  .portfolio-risk-concentration-theme button,\n  .portfolio-risk-concentration-theme [type='button'],\n  .portfolio-risk-concentration-theme [type='reset'],\n  .portfolio-risk-concentration-theme [type='submit'] {\n    -webkit-appearance: button;\n    background-color: transparent;\n    background-image: none;\n  }\n\n  .portfolio-risk-concentration-theme :-moz-focusring {\n    outline: auto;\n  }\n\n  .portfolio-risk-concentration-theme :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  .portfolio-risk-concentration-theme progress {\n    vertical-align: baseline;\n  }\n\n  .portfolio-risk-concentration-theme ::-webkit-inner-spin-button,\n  .portfolio-risk-concentration-theme ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  .portfolio-risk-concentration-theme [type='search'] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n\n  .portfolio-risk-concentration-theme ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  .portfolio-risk-concentration-theme ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n\n  .portfolio-risk-concentration-theme summary {\n    display: list-item;\n  }\n\n  .portfolio-risk-concentration-theme blockquote,\n  .portfolio-risk-concentration-theme dl,\n  .portfolio-risk-concentration-theme dd,\n  .portfolio-risk-concentration-theme figure,\n  .portfolio-risk-concentration-theme h1,\n  .portfolio-risk-concentration-theme h2,\n  .portfolio-risk-concentration-theme h3,\n  .portfolio-risk-concentration-theme h4,\n  .portfolio-risk-concentration-theme h5,\n  .portfolio-risk-concentration-theme h6,\n  .portfolio-risk-concentration-theme hr,\n  .portfolio-risk-concentration-theme p,\n  .portfolio-risk-concentration-theme pre {\n    margin: 0;\n  }\n\n  .portfolio-risk-concentration-theme fieldset {\n    margin: 0;\n    padding: 0;\n  }\n\n  .portfolio-risk-concentration-theme legend {\n    padding: 0;\n  }\n\n  .portfolio-risk-concentration-theme ol,\n  .portfolio-risk-concentration-theme ul,\n  .portfolio-risk-concentration-theme menu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .portfolio-risk-concentration-theme dialog {\n    padding: 0;\n  }\n\n  .portfolio-risk-concentration-theme textarea {\n    resize: vertical;\n  }\n\n  .portfolio-risk-concentration-theme input::placeholder,\n  .portfolio-risk-concentration-theme textarea::placeholder {\n    opacity: 1;\n    color: hsl(var(--muted-foreground));\n  }\n\n  .portfolio-risk-concentration-theme button,\n  .portfolio-risk-concentration-theme [role=\"button\"] {\n    cursor: pointer;\n  }\n\n  .portfolio-risk-concentration-theme :disabled {\n    cursor: default;\n  }\n\n  .portfolio-risk-concentration-theme img,\n  .portfolio-risk-concentration-theme svg,\n  .portfolio-risk-concentration-theme video,\n  .portfolio-risk-concentration-theme canvas,\n  .portfolio-risk-concentration-theme audio,\n  .portfolio-risk-concentration-theme iframe,\n  .portfolio-risk-concentration-theme embed,\n  .portfolio-risk-concentration-theme object {\n    display: block;\n    vertical-align: middle;\n  }\n\n  .portfolio-risk-concentration-theme img,\n  .portfolio-risk-concentration-theme video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .portfolio-risk-concentration-theme [hidden] {\n    display: none;\n  }\n\n  .portfolio-risk-concentration-theme h1,\n  .portfolio-risk-concentration-theme h2,\n  .portfolio-risk-concentration-theme h3,\n  .portfolio-risk-concentration-theme h4,\n  .portfolio-risk-concentration-theme h5,\n  .portfolio-risk-concentration-theme h6 {\n    font-family: 'Inter', system-ui, -apple-system, sans-serif;\n    font-weight: 600;\n    letter-spacing: -0.025em;\n  }\n\n  .portfolio-risk-concentration-theme a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  .portfolio-risk-concentration-theme button {\n    font-family: inherit;\n  }\n}\n\n/* Custom scrollbar - scoped */\n.portfolio-risk-concentration-theme ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.portfolio-risk-concentration-theme ::-webkit-scrollbar-track {\n  background-color: hsl(var(--background));\n}\n\n.portfolio-risk-concentration-theme ::-webkit-scrollbar-thumb {\n  background-color: hsl(var(--muted-foreground) / 0.3);\n}\n\n.portfolio-risk-concentration-theme ::-webkit-scrollbar-thumb:hover {\n  background-color: hsl(var(--muted-foreground) / 0.5);\n}\n\n/* Hide platform-ui elements when this feature is active */\nhtml.portfolio-risk-concentration-root .leftnav,\nhtml.portfolio-risk-concentration-root .main-wrapper,\nhtml.portfolio-risk-concentration-root > body > header {\n  display: none;\n}\n\n.portfolio-risk-concentration-theme header {\n  display: block !important;\n}\n\nhtml.portfolio-risk-concentration-root,\nhtml.portfolio-risk-concentration-root body {\n  background-color: hsl(218 22% 13%) !important;\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
